// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./components/config/assets/registration_page_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  height: 100% !important;
  margin: 0;
  overflow: auto;
}

.container {
  padding-right: 15px !important;
  padding-left: 15px !important;
  margin-right: auto !important;
  margin-left: auto !important;
}
body {
  height: 100%;
  margin: 0 !important;
  font-size: 14px !important;
  font-style: normal;
  color: #5c5c5c !important;
  text-decoration: none;
  font-weight: 300 !important;
  background: #fff;
  font-family: "Blogger Sans" !important;
}

ul li {
  list-style-type: none;
}

.top-header {
  padding: 10px 0;
  position: relative;
  box-shadow: 0 0 4px 0 #ccc;
}

ul.left-bar-menu {
  padding: 0;
  margin: 0;
  float: right;
  margin: 0;
  padding: 0;

}

ul.left-bar-menu li a {
  color: green;
  font-size: 15px;
  font-weight: 400;
  font-family: "Blogger Sans" !important;
}

.aboutusdv p {
  color: #878787;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-align: justify;
  font-family: "Blogger Sans" !important;
  font-size: 14px !important;
}

ul.righ-bar-menu li {
  padding: 8px 10px;
  right: 0;
  position: relative;
}

p {
  font-family: "Blogger Sans" !important;
  font-size: 14px !important;
}

select {
  padding: 3px;
  font-family: "Blogger Sans" !important;
}

.right-inner-addon.is-active {
  position: relative;
  margin-bottom: 20px;
  width: 108%;
  right: 15px;
  padding: 13px 13px 0;
  margin-left: -15px;
}

a.link-bottom-footer {
  font-weight: bold !important;
  color: #fff;
  font-size: 15px !important;
  font-family: "Blogger Sans" !important;

}


i.fa.fa-angle-down.down-arrow {
  font-size: 20px;
  position: relative;
  top: 3px;
  line-height: 0;
  left: 3px;
  color: green;
}

ul.hdr-scl {
  margin: 0;
}

ul.hdr-scl li a i {
  font-size: 20px;
}

span.dropdown-toggle:hover ul.dropdown-menubar {
  display: block;
  margin-top: 10px;
  margin-left: 12px;
}

span.dropdown-toggle {
  padding: 21px 10px;
}

.hdr-social {
  text-align: center;
  margin: 37px 0 20px;
}

.form-group .form-control:focus {
  box-shadow: none;
}

.ctnform textarea {
  width: 100%;
  display: block;
  border: none;
  height: 100px;
  padding: 15px;
  background-color: #efefef;
  border: none;
  margin-bottom: 25px;
  border-radius: 4px;
}

ul.footermenu li a {
  font-family: "Blogger Sans" !important;
  font-size: 15px;
  text-decoration: none;
  font-weight: 300;
}

ul.footermenu li {
  display: block;
  font-family: "Blogger Sans" !important;
}

.foot-add p {
  font-size: 15px;
  margin-right: 30px;
}

.created-info {
  font-family: "Blogger Sans" !important;
}

span.hdr-social ul.hdr-scl li i {
  padding: 5px;
}

.foot-add .created-info {
  margin-top: 12px;
  font-size: 15px;
  margin-bottom: 9px;
}

ul.nav.navbar-nav li.hover-dropdown ul.dropdown-menubar li a {
  color: green;
}

.addressact span.shipping-action a {
  font-size: 18px;
  padding-right: 6px;
}

li.hover-dropdown:hover i.fa.fa-angle-down.down-arrow {
  color: #fff;
}

.addressact {
  width: 20%;
}

.change-password-title {
  text-align: center;
  margin-bottom: 20px;
}

.mored-sec h4 {
  font-size: 14px;
}

.service-heading {
  color: #878787 !important;
  /* text-transform: uppercase; */
  font-size: 20px !important;
  font-weight: bold;
  letter-spacing: 0.05em;
  margin-bottom: 30px;
  margin-top: 35px;
  font-family: "Blogger Sans" !important;
  line-height: 1.3;
}

.text-muted {
  color: #878787;
  line-height: 28px;
  padding: 0;
  letter-spacing: 0.05em;
  margin-bottom: 25px;
  font-family: "Blogger Sans" !important;
  font-size: 14px !important;
  font-weight: 400 !important;
}

span.number-text {
  background: #ccc;
  width: 25px;
  height: 25px;
  text-align: center;
  border-radius: 50%;
  padding: 4px;
  font-size: 14px;
  font-weight: 700;
  display: block;
  color: #000;
  margin-top: 4px;
  margin-right: 10px;
}

.box-shadow-box {
  box-shadow: 0 0 5px 0 #ccc;
  padding: 25px 30px;
  margin-top: 20px;
  border-radius: 4px;
}

img.img-bankcard {
  width: 230px;
  margin-top: 10px;
  margin-bottom: 10px;
}

h4.title-details {
  font-size: 22px;
  font-weight: 600;
  color: #000;
  font-family: "Blogger Sans" !important;
}

table.tbl-order-cart {
  width: 100%;
  font-family: "Blogger Sans" !important;
}

table.tbl-order-cart tr {
  background: transparent;
}

table.tbl-order-cart th {
  padding: 8px 15px;
  border-bottom: 1px solid #ccc;
}

table.tbl-order-cart td {
  padding: 8px 15px;
  border-bottom: 1px solid #ccc;
}

.billing-address-sec p {
  margin-bottom: 4px;
  font-family: "Blogger Sans" !important;
}

.title-pretext {
  font-family: "Blogger Sans" !important;
}

.btn-previous-tabs {
  background: green;
  color: #fff;
}

.btn-next-tabs {
  background: green;
  color: #fff;
}

.button-row {
  margin-top: 20px;
}

.btn-right {
  float: right;
}

span.border-saprate {
  background: #ccc;
  width: 58%;
  height: 1px;
  margin: 14px 0;
  margin-left: 0;
}

span.required-mark {
  color: red;
}

.custom-table-style tr td:first-child {
  text-align: left;
  font-family: "Blogger Sans" !important;
}

.dateicon {
  background-size: 18px !important;
  background-position: right 10px center !important;
  background-repeat: no-repeat !important;
}

.timeicon {
  background-size: 20px !important;
  background-repeat: no-repeat !important;
  background-position: 99% !important;
}

.order-billing-section .form-control {
  font-family: "Blogger Sans" !important;
}

select {
  background-position-x: 99% !important;
}

.banner-section {
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 110px 0 255px;
  background-position: center bottom;
}

.banner-section1 {
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 115px 0;
  background-position: center center;
}

.bathing-text {
  font-size: 30px;
  font-weight: 600;
  color: #fff;
  font-family: "Blogger Sans" !important;
}

.img-cleanses {
  width: 85%;
  height: 100%;
}

.ozone-heading {
  color: green;
  font-size: 48px;
  font-weight: 700;
  font-family: "Blogger Sans" !important;
}

.atopic-dermatitis {
  font-size: 20px;
  font-weight: 600;
  color: #3b3b3b;
  font-family: "Blogger Sans" !important;
}

.ozone-content {
  margin-top: 40px;
}

.bacteria {
  width: 70px;
  display: flex;
  padding: 10px;
  align-items: center;
  justify-content: center;
}

.allergy-icon {
  border: 2px solid #377d22;
  width: 75px;
  border-radius: 50%;
  height: 75px;
  margin: 0 auto;
}

.bacteria-title {
  margin-top: 15px;
  font-size: 16px;
}

.ozone-row {
  padding: 0 70px;
}

.bacteria-col {
  text-align: center;
  margin-top: 20px;
}


.destroy-viruses-section {
  background: linear-gradient(green, #88ca73);
  padding: 70px 0;
  margin-bottom: 80px;
}

.viruses-text {
  color: #fff;
  text-align: center;
  padding: 0 50px;
}

.virus {
  font-size: 48px;
  font-weight: 700;
  font-family: "Blogger Sans" !important;
}

.study {
  font-size: 36px;
}

.product-features-section {
  padding: 0 50px;
  margin-bottom: 80px;
}

.product-title {
  font-size: 22px;
  text-transform: uppercase;
  text-align: center;
  font-weight: 500;
  color: #3b3b3b;
  font-family: "Blogger Sans" !important;
}

.fungicidal-properties {
  font-weight: 600;
  padding: 30px 60px;
  text-align: center;
  color: #3b3b3b;
  font-size: 36px;
  line-height: 50px;
  font-family: "Blogger Sans" !important;
}

.anti-inflammatory-properties-left {
  margin-top: 50px;
}

.anti-inflammatory {
  text-align: right;
  font-size: 24px;
  font-weight: 600;
  margin-bottom: 50px;
  line-height: 32px;
  color: #3b3b3b;
  position: relative;
  font-family: "Blogger Sans" !important;
}

p.anti-inflammatory:after {
  content: "";
  position: absolute;
  background: #377d22;
  height: 30px;
  width: 4px;
  right: -10px;
  top: 0;
}

.image-inflam {
  width: 100%;
  border: 1px solid #dbdbdb;
  padding: 10px;
}

.anti-inflammatory-properties-right {
  margin-top: 50px;
}

p.anti-parasitic {
  text-align: left;
}

p.anti-parasitic:after {
  left: -10px;
  right: unset;
}

.text-section {
  font-size: 16px;
  color: #3b3b3b;
  line-height: 24px;
  font-family: "Blogger Sans" !important;
}

.additives p {
  color: green;
  font-size: 28px;
  line-height: 32px;
}

.product-contain {
  padding: 0 60px;
}

.microoragnisms-section {
  background-color: #f7f7f7;
  margin-top: 50px;
}

.img-product-2 {
  width: 100%;
  height: 100%;
}

.microoragnisms-content-section {
  margin: 50px 50px 0;
}

.microoragnisms-text h2,
h4 {
  font-weight: 600;
  color: #3b3b3b;
}

.microoragnisms-text h4 {
  margin-top: 25px;
  line-height: 24px;
}

.aging-img .process {
  width: 70px;
  padding: 10px;
}

.aging-process-section {
  display: flex;
  margin-top: 40px;
  width: 80%;
}

.aging-img {
  border: 2px solid green;
  width: 75px;
  border-radius: 50%;
  height: 75px;
  margin: 0 auto;
}

.aging-text {
  margin-left: 20px;
  color: #3b3b3b;
  width: 80%;
}

.aging-text h3 {
  font-weight: 600;
  padding-bottom: 10px;
}

.aging-text p {
  line-height: 20px;
}

img.img-odorless {
  width: 91%;
  display: block;
  margin: 0 auto;
}

.odorless-section {
  position: relative;
  padding: 80px 0;
}

h2.title-odorless {
  font-size: 36px;
  color: #3b3b3b;
  font-weight: 600;
  width: 56%;
  margin: 0 auto;
  text-align: center;
  line-height: 50px;
}

p.title-ozone-renew {
  width: 74%;
  margin: 20px auto 50px;
  text-align: center;
  color: #3b3b3b;
  line-height: 24px;
  font-size: 16px;
}

a.btn-buy-now {
  position: absolute;
  left: 34%;
  bottom: 20px;
  background: green;
  color: #fff;
  padding: 14px 40px;
  border-radius: 4px;
}

a.btn-buy-now:hover {
  color: #fff;
}

.booking-tabs-topbar {
  padding: 60px 0;
}

.booking-test-group {
  display: grid;
  grid-template-columns: 14% 14% 14% 14% 14% 12% 12% 6%;
}

.tabs-steps-group {
  position: relative;
}

.round-steps-box {
  width: 27px;
  height: 27px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #878787;
  background: #fff;
}

.round-steps-box:before {
  content: "";
  height: 2px;
  width: 100%;
  position: absolute;
  background: #ccc;
  top: 13px;
  left: 27px;
}

.active_tabs .round-steps-box {
  background: green;
  border-color: green;
}

.active_tabs .round-steps-box:before {
  background: green;
}

.booking-test-group .tabs-steps-group:last-child .round-steps-box:before {
  content: none;
}

.tabs-steps-group h4 {
  font-size: 16px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 0;
  color: #878787;
  line-height: 1.2;
  margin-right: 60px;
}

.active_tabs h4 {
  color: green;
}

.thank-you-message h2,
.thank-you-message h3 {
  color: #6c6c6c;
  font-size: 58px;
}

.thank-you-message {
  text-align: center;
  margin-bottom: 50px;
}

.thank-you-message a {
  display: inline-block;
  margin-top: 30px;
  padding: 12px 20px;
  color: #fff !important;
}

.round-steps-box i.icon-checked {
  font-size: 14px;
  color: #fff;
}

.steps-main-section {
  padding-bottom: 60px;
}

.steps-main-groups {
  border: 1px solid #ccc;
  border-radius: 4px;
  position: relative;
}

.company-details-section,
.sops-details-section,
.site-visit-details-section,
.warehouse-details-section,
.products-details-section {
  padding: 50px;
  position: relative;
}

.booking-main-section {
  position: relative;
}

.contacts-details-section,
.regulatory-contact-details-section,
.agreement-details-section,
.sops-details-section,
.site-visit-details-section,
.warehouse-details-section,
.products-details-section {
  display: none;
  position: relative;
}

.test-tooltip-section {
  border: 1px solid #ccc;
  border-radius: 4px;
  position: absolute;
  padding: 6px 10px 5px;
  right: 5px;
  top: -48px;
  display: none;
  transition: 0.4s;
  background: #fff;
}

.which-type-test:hover~.test-tooltip-section {
  display: block;
}

.test-tooltip-section:after {
  bottom: -6px;
  right: 15px;
  content: "";
  height: 10px;
  width: 10px;
  position: absolute;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;
  transform: rotate(-135deg);
  background: #fff;
}

.test-tooltip-section p {
  font-size: 16px;
  color: #5c5c5c;
  margin: 0;
  margin-bottom: 0;
}

.cancel-sign-btn {
  position: absolute;
  right: 42px;
  bottom: 10px;
  border: none;
  background: green;
  color: #fff;
  padding: 6px 8px;
  border-radius: 4px;
}

.signature-group canvas {
  position: relative;
  border-radius: 4px;
  border: 1px solid #ccc;
}

.signature-group {
  width: 100%;
  position: relative;
}

.btn-save-signature {
  background: green;
  color: #fff;
  border: none;
}

.steps-main-section .form-label-title {
  line-height: 1.25;
  color: #5c5c5c;
  margin-bottom: 8px;
  font-weight: 400;
  font-family: "Blogger Sans" !important;
}

.steps-main-section .form-control {
  border: 1px solid #ccc;
  border-radius: 4px !important;
  font-size: 14px !important;
  font-family: "Blogger Sans" !important;
  color: #121212;
}

.steps-main-section .form-group {
  margin-bottom: 30px;
}

.form-main-title {
  font-size: 26px;
  color: green;
  font-weight: 600;
  margin-bottom: 40px;
}

.form-footer-main {
  text-align: right;
  margin-top: 50px;
}

.btn-cust-next,
.btn-cust-back {
  border: 1px solid green;
  background: green;
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  font-family: "Blogger Sans" !important;
  padding: 8px 22px;
  line-height: 1;
  border-radius: 4px;
}

.btn-cust-back {
  background: #fff;
  color: green;
  margin-right: 16px;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.border-saprate-row {
  display: block;
  width: 100%;
  border-top: 1px dashed #ccc;
  margin-top: 10px;
  margin-bottom: 40px;
}

.contacts-details-section,
.regulatory-contact-details-section {
  padding-top: 50px;
  padding-bottom: 50px;
}

.contacts-details-section .row,
.contacts-details-section .form-main-title,
.contacts-details-section .form-footer-main,
.regulatory-contact-details-section .row,
.regulatory-contact-details-section .form-main-title,
.regulatory-contact-details-section .form-footer-main {
  padding-left: 50px;
  padding-right: 50px;
}

.radio-group {
  display: inline-block;
  position: relative;
  margin-right: 40px;
}

.radio-group input[type="radio"] {
  display: none;
}

.radio-group label {
  color: #5c5c5c;
  font-weight: 400;
  margin: 0;
}

.radio-group label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  margin-right: 10px;
  width: 20px;
  height: 20px;
  border-radius: 11px;
  border: 2px solid #878787;
  background-color: transparent;
}

.radio-group input[type="radio"]:checked+label:after {
  border-radius: 11px;
  width: 12px;
  height: 12px;
  position: absolute;
  top: 9px;
  left: 4px;
  content: " ";
  display: block;
  background: green;
}

.radio-group input[type="radio"]:checked+label {
  color: green;
}

.radio-group input[type="radio"]:checked+label:before {
  border: 2px solid green;
}

.sops-radio-group .radio-group label:before {
  margin: 0;
}

.checkbox-group input[type="checkbox"] {
  display: none;
}

.checkbox-group label {
  color: #5c5c5c;
  font-weight: 400;
  margin: 0;
}

.checkbox-group label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 5px;
  width: 20px;
  height: 20px;
  border-radius: 4px;
  border: 2px solid #878787;
  background-color: transparent;
  margin-right: 10px;
}

.checkbox-group input[type="checkbox"]:checked+label:after {
  position: absolute;
  content: " ";
  display: block;
  left: 7px;
  top: 7px;
  width: 7px;
  height: 12px;
  border: solid #fff;
  border-width: 0 3px 3px 0;
  transform: rotate(45deg);
}

.checkbox-group input[type="checkbox"]:checked+label {
  color: green;
}

.checkbox-group input[type="checkbox"]:checked+label:before {
  border: 2px solid green;
  background: green;
}

.which-type-test {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid #878787;
  border-radius: 50%;
  font-size: 14px;
  line-height: 1;
  padding: 0 5px;
  font-weight: 700;
  margin-left: 0;
  position: relative;
  top: 0;
  cursor: pointer;
}

.sops-title-group span {
  font-size: 16px;
  color: #5c5c5c;
  font-weight: 500;
  margin-right: 40px;
  margin-bottom: 10px;
  display: inline-block;
}

.form-body-title {
  color: #5c5c5c;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.35;
  margin-bottom: 15px;
}

.agreement-point-section li {
  color: #5c5c5c;
  font-size: 16px;
  line-height: 1.35;
  margin-bottom: 30px;
}

.checkbox-group {
  width: 100%;
  position: relative;
}

.checkbox-group label {
  font-weight: 400;
}

.agreement-details-section {
  padding-top: 50px;
  padding-bottom: 50px;
}

.agreement-details-section .agreement-point-section,
.agreement-details-section .form-main-title,
.agreement-details-section .row,
.agreement-details-section .form-body-title,
.agreement-details-section .form-footer-main {
  padding-left: 50px;
  padding-right: 50px;
}

.reuired-sign {
  color: red;
}

.error_message {
  color: red;
  margin-top: 4px;
  display: inline-block;
  font-size: 14px;
}

.sops-details-section .error_message,
.site-visit-details-section .error_message,
.warehouse-details-section .error_message,
.products-details-section .error_message {
  margin-left: 5px;
}

.agreement-point-section {
  margin-bottom: 40px;
}

.register-link-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 19px;
}

.register-page-link {
  padding: 70px 0;
}

.registerbox {
  text-align: center;
  margin: 0;
  position: relative;
  width: 220px;
  height: 218px;
  border: 1px solid #989898;
  transition: 0.1s;
}

.registerbox h4 {
  margin-top: 35px;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.35;
  color: #989898;
  text-decoration: none;
  font-family: "Blogger Sans";
}

.registerbox:hover h4 {
  color: green;
}

.registerbox a {
  color: green;
}

.register-link-group a {
  display: inline-block;
}

.registerbox .img-centered {
  margin-top: 40px;
}



.sops-title-group span:last-child {
  margin-right: 0;
}

.sops-radio-group .radio-group:last-child {
  margin-right: 0;
}

/* .registration_details {
  padding-top: 20px;
  padding-bottom: 40px;
}

.registration_details .details_heading_section {
  display: flex;
  justify-content: space-between;
  color: green;
  padding: 12px;
  background-color: #f3fbf3;
  margin-bottom: 20px;
} */

.details_heading {
  font-size: 22px;
  font-weight: 400;
  line-height: 22px;
  margin: 0;
}

.details_name_sec .details_txt {
  font-size: 16px;
}

.details_name_sec .details_title {
  font-size: 18px;
}

.sops_training label {
  margin-bottom: 0;
}

.details_list_section .border-remove-table {
  padding: 0;
}

.border-remove-table table tr:last-child td {
  border-bottom: 0;
}

.border-remove-table table tr:first-child td {
  border-top: 0;
}

.border-remove-table table tr:last-child td:first-child {
  border-left: 0;
}

.border-remove-table table tr:last-child td:last-child {
  border-right: 0;
}

.btn_section {
  border-top: 1px solid #d9d9d9;
}

.btn_back {
  border-radius: 4px;
  border: 1px solid green;
  color: green;
  padding: 8px 19px;
  color: green;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  margin-right: 0px;
  background-color: #ffffff;
}

.btn_submit {
  border-radius: 4px;
  background: green;
  color: #fff;
  padding: 8px 19px;
  font-size: 16px;
  font-weight: 500;
  line-height: 16px;
  border: none;
}

.btn_back_submit {
  padding-top: 30px;
  padding-bottom: 5px;
  display: flex;
  justify-content: end;
}

.btn_back_submit button {
  font-family: "Blogger Sans" !important;
}

/* .registration_details_list {
  margin-top: 40px;
}

.registration_details_list.agreement tr:last-child td {
  background: #f3f3f3;
} */

.signature_img {
  width: 150px;
  height: 80px;
  display: block;
}

.company_details td,
.contact_details td,
.regulatory_contact_details td {
  border: none;
}

.company_details .details_list_section,
.contact_details .details_list_section,
.regulatory_contact_details .details_list_section {
  border: 1px solid #ccc;
}

.regulatory-contact-details-section .text-techinical-agreement .text-techinical {
  color: green;
  font-weight: 600;
  text-decoration: underline;
  line-height: 1.4;
}

.regulatory-contact-details-section .text-techinical-agreement .text-techinical:hover,
.regulatory-contact-details-section .text-techinical-agreement .text-techinical:focus {
  color: #ea4a30;
  font-weight: 600;
  text-decoration: underline;
}

.rdio_main_inp {
  display: none !important;
}

input#wdaAttachedFile:focus {
  outline: none;
}

.register_section .step-progress {
  display: none;
}

.text-techinical-agreement span {
  color: green;
  font-weight: 600;
}

.text-techinical-agreement {
  font-size: 13px;
  margin-bottom: 6px;
  display: inline-block;
  color: green;
  text-decoration: underline;
  font-weight: 600;
}

.text-techinical {
  color: green;
}

@media screen and (min-width: 1200px) {
  .registerbox:hover {
    border: 4px solid #989898;
  }
}

@media screen and (max-width: 1024px) and (min-width: 1000px) {
  .register-link-group a:last-child {
    margin-right: 0;
  }

  .register-link-group a:first-child {
    margin-left: 0;
  }

  .register-link-group a {
    margin: 0 10px;
  }

  .radio-group {
    margin-right: 20px;
  }

  .sops-title-group span {
    margin-right: 20px;
  }
}

@media screen and (max-width: 1024px) {
  .tabs-steps-group h4 {
    margin-right: 20px;
  }

  .form-main-title {
    margin-bottom: 20px;
  }

  .company-details-section,
  .sops-details-section,
  .site-visit-details-section,
  .warehouse-details-section,
  .products-details-section {
    padding: 25px;
  }

  .contacts-details-section .row,
  .contacts-details-section .form-main-title,
  .contacts-details-section .form-footer-main,
  .regulatory-contact-details-section .row,
  .regulatory-contact-details-section .form-main-title,
  .regulatory-contact-details-section .form-footer-main {
    padding-left: 25px;
    padding-right: 25px;
  }

  .agreement-details-section .agreement-point-section,
  .agreement-details-section .form-main-title,
  .agreement-details-section .row,
  .agreement-details-section .form-body-title,
  .agreement-details-section .form-footer-main {
    padding-left: 25px;
    padding-right: 25px;
  }

  .agreement-details-section,
  .contacts-details-section,
  .regulatory-contact-details-section {
    padding-top: 25px;
    padding-bottom: 25px;
  }

  .border-saprate-row {
    margin-top: 0;
    margin-bottom: 20px;
  }

  .steps-main-section .form-group {
    margin-bottom: 20px;
  }

  .form-footer-main {
    margin-top: 30px;
  }
}

@media screen and (max-width: 992px) {
  .tabs-steps-group h4 {
    display: none;
  }

  .register-link-group {
    justify-content: center;
  }

  .register-link-group a {
    margin-bottom: 30px;
  }

  .i-want-to-register {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 992px) and (min-width: 768px) {
  .product-features-section .col-md-4 {
    width: 33.33%;
    float: left;
  }

  .microoragnisms-section .col-md-6 {
    width: 50%;
    float: left;
  }

  .odorless-section .col-md-4 {
    width: 33.33%;
    float: left;
  }
}

@media screen and (max-width: 768px) {
  ul.righ-bar-menu {
    float: none;
    margin-top: 0px;
  }

  ul.righ-bar-menu li:first-child {
    padding-left: 10px;
  } 
    ul.righ-bar-menu {
        float: none;
        padding-left: 5px;
        margin-top: 0px !important;
    }
  .banner-section {
    background-size: cover;
    padding: 60px 0 100px;
  }

  .bathing-text {
    font-size: 20px;
  }

  .ozone-row {
    padding: 0;
  }

  .ozone-heading {
    font-size: 30px;
  }

  .virus {
    font-size: 30px;
  }

  .study {
    font-size: 22px;
  }

  .fungicidal-properties {
    padding: 30px 0;
    font-size: 30px;
    line-height: 35px;
  }

  .product-contain {
    padding: 0;
  }

  .product-features-section {
    padding: 0;
  }

  .anti-inflammatory {
    margin-bottom: 30px;
    text-align: left;
    padding-left: 10px;
  }

  .anti-inflammatory-properties-left {
    margin-top: 0;
  }

  .anti-inflammatory-properties-right {
    margin-top: 30px;
  }

  .img-cleanses {
    width: 100%;
  }

  h2.title-odorless {
    font-size: 36px;
    color: #3b3b3b;
    font-weight: 600;
    width: 80%;
    margin: 0 auto;
    text-align: center;
    line-height: 38px;
  }

  img.img-odorless {
    margin-bottom: 50px;
  }

  .destroy-viruses-section {
    margin-bottom: 50px;
  }

  .aging-process-section {
    width: 100%;
  }
}


  .registerbox {
    width: 100%;
  }

  .register-link-group {
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
  }

  .register-page-link {
    padding: 70px 0px;
  }

  .registerbox {
    text-align: center;
    margin: 0px;
    position: relative;
    width: 220px;
    height: 218px;
    border: 1px solid #989898;
    transition: 0.1s;
  }

  .registerbox h4 {
    margin-top: 35px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.35;
  }

  .registerbox:hover h4 {
    color: #008000;
  }

  .registerbox a {
    color: #008000;
  }

  .register-link-group a {
    display: inline-block;
  }

  .registerbox .img-centered {
    margin-top: 40px;
  }

  /* .i-want-to-register {
    font-size: 17px !important;
    font-weight: 600;
    color: #008000;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 65px;
  } */

  .company-details-section,
  .sops-details-section,
  .site-visit-details-section,
  .warehouse-details-section,
  .products-details-section {
    padding: 15px;
  }

  .contacts-details-section .row,
  .contacts-details-section .form-main-title,
  .contacts-details-section .form-footer-main,
  .regulatory-contact-details-section .row,
  .regulatory-contact-details-section .form-main-title,
  .regulatory-contact-details-section .form-footer-main {
    padding-left: 15px;
    padding-right: 15px;
  }

  .agreement-details-section .agreement-point-section,
  .agreement-details-section .form-main-title,
  .agreement-details-section .row,
  .agreement-details-section .form-body-title,
  .agreement-details-section .form-footer-main {
    padding-left: 15px;
    padding-right: 15px;
  }

  ul.righ-bar-menu .contact-menu {
    padding-left: 0;
  }

  span.dropdown-toggle {
    padding-left: 0;
    padding-right: 0;
  }

  .hdr-social {
    text-align: center;
    margin: 10px 16px 20px;
  }

  .viruses-text {
    padding: 0;
  }

  .destroy-viruses-section {
    padding: 50px 0;
    margin-bottom: 50px;
  }

  .microoragnisms-content-section {
    margin: 15px;
  }

  .microoragnisms-section {
    padding-bottom: 50px;
  }

  h2.title-odorless {
    font-size: 30px;
    width: 100%;
    line-height: 35px;
  }

  .odorless-section {
    position: relative;
    padding: 50px 0;
  }

  p.title-ozone-renew {
    width: 100%;
    margin: 20px auto 40px;
  }

  img.img-odorless {
    width: 100%;
    margin: 0 auto 20px;
  }

  p.anti-inflammatory:after {
    right: unset;
    left: 0;
  }

  .additives p {
    font-size: 22px;
    line-height: 30px;
    font-family: "Blogger Sans", sans-serif !important;
  }

  .product-features-section {
    margin-bottom: 50px;
  }

  .microoragnisms-text {
    margin-top: 30px;
  }

  .microoragnisms-text h2,
  h4 {
    font-size: 22px;
    font-family: "Blogger Sans", sans-serif !important;
  }

  .bacteria-title {
    margin-top: 10px;
  }

  .bacteria-col {
    margin-top: 30px;
  }


@media screen and (max-width: 320px) {
  a.btn-buy-now {
    bottom: 10px;
  }
}

.widget-title {
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 22px;
  color: #fff;
}

.foot-add {
  background-color: green;
  text-align: center;
  height: 50px;
  margin-top: 30px;
}

.hdr-scl a {
  color: #fff;
}

.foot-add1 {
  background-color: green;
  margin-top: 30px;
  padding-top: 50px;
}

.company_number {
  font-weight: 700;
}

.foot-add p {
  padding-top: 11px;
  font-family: "Blogger Sans" !important;
  line-height: 30px;
  margin-bottom: 0;
  color: #fff;
}

.hdr-social {
  margin: 0 3px 14px;
}

.terms-condition-section {
  margin-bottom: 20px;
  margin-top: 30px;
}

span.fb-ftr {
  margin-right: 20px;
  font-size: 52p;
}

.hdr-scl span {
  display: inline-block;
  position: relative;
  padding: 20px 30px;
}

.hdr-scl span:before {
  content: "";
  position: absolute !important;
  width: 500px !important;
  border-top: 1px solid #b6c7d6 !important;
  height: 3px !important;
  top: 50% !important;
  margin-top: -3px !important;
}

.hdr-scl:after {
  content: "";
  position: absolute;
  width: 500px;
  border-top: 1px solid #b6c7d6;
  height: 3px;
  bottom: 48px;
  right: 20px;
}

.hdr-scl span:before {
  right: 100%;
}

.hdr-scl span:after {
  left: 100%;
}

i.fa.fa-facebook {
  padding-right: 20px;
  font-size: 24px;
}

i.fa.fa-linkedin {
  font-size: 24px;
}

.foot-add {
  background-color: green;
  text-align: center;
  height: 50px;
  margin-top: 30px;
}

.foot-add p {
  padding-top: 11px;
  font-family: "bloggerSans" !important;
  font-family: "Blogger Sans" !important;
  line-height: 30px;
  color: #fff;
}

.footermenu {
  padding: 0;
  list-style: none;
  line-height: 26px;
}

.footermenu li a {
  color: #fff;
}

.footermenu li a:hover {
  color: #fff;
}

.footermenu li {
  font-size: 15px !important;
  color: #fff;
  margin-bottom: 5px;
}

a.terms {
  color: #fff;
  text-align: center;
  font-family: "Blogger Sans" !important;
  text-decoration: none;
  font-style: 14px;
}

.created-info {
  margin-top: 0;
  margin-bottom: 7px;
  text-align: center;
  color: #fff;
  margin-right: 21px;
  font-size: 14px !important;
}

.develop {
  margin-bottom: 50px;
}

.aboutusdv:last-child {
  margin-bottom: 66px;
}

.service-image_new img {
  max-width: 89%;
  height: 143px;
  border-radius: 100%;
  border: 1px solid green;
}

.login-dropdown a {
  padding: 20px 0;
}

.login-dropdown:hover .down-arrow {
  color: green !important;
}

.open_custom_menu {
  display: block !important;
}

.form-group label {
  font-size: 15px !important;
  font-weight: 400 !important;
}

.mat-label {
  display: block;
  font-size: 16px;
  transform: translateY(18px);
  color: #979797;
  transition: all 0.2s;
  font-family: Verdana, sans-serif !important;
}

.is-completed .mat-label {
  font-weight: 400;
  font-size: 11px !important;
  transform: translateY(0);
}

.added {
  padding: 15px;
}

.form-group .form-control-mat-input1 {
  display: block;
  font-size: 16px;
  font-family: "Blogger Sans" !important;
  border-radius: 4px;
  width: 100%;
  height: 34px;
  padding: 6px 12px;
  margin-top: 10px;
  box-shadow: none;
  outline-offset: none;
  background: transparent !important;
}

.form-group .form-control {
  border: none;
  border-radius: inherit;
  box-shadow: none;
  outline-offset: none;
  background: transparent !important;
}

.step-content-foot {
  text-align: center;
  padding: 20px 0 50px;
}

.step-content-foot button.active {
  background-color: #008000;
  color: #fff;
  font-family: "Blogger Sans" !important;
  /* font-size: 14px; */
  border-radius: 22px;
  padding: 8px 40px;
}

.owl-theme .owl-item img {
  display: block;
  width: 193px;
}

a {
  text-decoration: none !important;
  cursor: pointer;
  outline: none;
  color: #5c5c5c;
  font-size: 14px;
}

.select_opt {
  margin-top: 10px;
  width: 100% !important;
  margin-left: 0px;
}

.formdetailstitle {
  text-align: center;
  font-family: "Vardana", sans-serif !important;
  font-size: 24px !important;
  color: #0f870f;
  text-transform: capitalize;
  width: 100%;
  line-height: 0.1em;
  margin: 10px 0 20px;
}

.aboutusdv h1 {
  color: hsl(153, 100%, 20%);
  font-size: 26px;
  font-weight: 600;
  line-height: 1.3em;
  margin-bottom: 0;
  font-family: "Blogger Sans" !important;
  padding: 0 0 12px;
}

.aboutusdv p {
  color: #878787;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-align: justify;
  font-family: "Blogger Sans" !important;
  font-size: 14px !important;

}

.aboutusdv ol li {
  color: #878787;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-align: justify;
  font-family: "Blogger Sans" !important;
  font-size: 14px !important;
}

li {
  white-space: normal;
  display: inline-block;
  padding: 0;
  margin: 0;
}

h4 {
  color: green !important;
  text-decoration: none !important;
  padding-bottom: 15px;
  font-weight: 600;
  margin-top: 28px;
  margin-bottom: -8px;
}

b,
strong {
  font-weight: 700;
}

.aboutusdv ul li {
  color: #878787;
  line-height: 28px;
  letter-spacing: 0.05em;
  text-align: justify;
  font-family: "Blogger Sans" !important;
  font-size: 14px;
}

div#designer-details {
  background: green;
}

.cookie-foot-add {
  background-color: green;
  text-align: center;
  height: 50px;
  margin-top: 30px;
}

.cookie-foot-add p {
  padding-top: 11px;
  font-family: "Blogger Sans" !important;
  line-height: 30px;
  margin-bottom: 0;
  color: #fff;
}

.footermenu {
  padding: 0;
  list-style: none;
}

.add {
  font-size: 15px;
  color: #7b7b7b;
  margin-bottom: 5px;
}

.add-btn {
  color: #7b7b7b;
}

.add-btn:hover {
  color: green;
}

.ctnform input {
  width: 100%;
  display: block;
  border: none;
  height: 40px;
  padding: 0 15px;
  background-color: #efefef;
  border: none;
  margin-bottom: 25px;
  border-radius: 4px;
}

.cookie-foot-add .hdr-scl {
  list-style: none;
}

.cookie-foot-add .hdr-social {
  float: right;
  margin: 10px 0;
}

.cookie-foot-add .hdr-scl li {
  display: inline-block;
  width: 30px;
  height: 30px;
  line-height: 28px;
  background-color: #999;
  text-align: center;
}

.cookie-foot-add .hdr-scl li:hover {
  background: green;
}

.cookie-foot-add .hdr-scl li:hover a {
  color: #fff;
}

.cookie-foot-add .hdr-scl a {
  color: #fff;
}

.cookie-foot-add p {
  display: inline-block;
}

.cookie-foot-add .hdr-scl li.lk-ftr:hover {
  background-color: #0077b5 !important;
}

.cookie-foot-add .hdr-scl li.fb-ftr:hover {
  background-color: #3c5798 !important;
}

li.fb-ftr {
  margin-right: 15px;
}

input:focus {
  color: #111 !important;
}

.cookie-foot-add .created-info {
  margin-top: 0;
  margin-bottom: 7px;
  width: 91%;
  color: #fff;
}

.cookie-foot-add .hdr-social {
  margin-bottom: 0;
  position: relative;
  bottom: -15px;
}

.cookie-foot-add .hdr-scl:after {
  display: none;
  content: "";
  position: absolute;
  width: 500px;
  border-top: 1px solid #b6c7d6;
  height: 3px;
  top: 41%;
  margin-top: -3px;
}


.registerdiv,
.logindiv {
  margin-top: 150px;
}

.logo-margin {
  padding: 10px 0 20px;
}

.error {
  color: red;
}

.logotxt1 {
  color: green;
  font-weight: 700;
  font-size: 26px;
}

.logotxt2 {
  color: #878787;
  font-weight: 700;
  font-size: 26px;
}

.forgotlable {
  font-size: 12px;
  float: right;
  margin: -10px 0 10px;
}

.btn {
  padding: 10px !important;
  font-size: 11px !important;
  font-weight: 700 !important;
  letter-spacing: 0;
  text-transform: uppercase;
  color: #fff !important;
  background-color: #008000 !important;
  border-color: #008000 !important;
}

.form-control {
  border-radius: 0;
  font-weight: 400;
  padding: 5px;
}

a {
  outline: none;
  font-family: "Open Sans";
  text-decoration: none;
}

a {
  color: #337ab7;
  text-decoration: none;
}

.panel-default>.panel-heading {
  color: #333 !important;
  background-color: #f5f5f5 !important;
  font-size: 16px !important;
  font-family: Calibari !important;
}

.panel-heading {
  padding: 10px 15px !important;
}

.card {
  margin-bottom: 15px;
  padding: 18px 10px;
  border: 0 solid #e7e7e7;
  border-radius: 4px;
  box-shadow: 0 5px 20px #0000000d;
  display: inline-block;
  width: 100%;
}

.media-left i {
  font-size: 45px;
  color: green;
}

.media-text-right {
  float: right;
  display: inline-block;
  text-align: right;
}

.media-left {
  display: inline-block;
}

.media-text-right h2 {
  font-size: 24px;
  margin-bottom: 10px;
  font-family: Calibri;
  font-weight: 600;
}

.media-text-right p {
  margin: 0;
  font-family: Calibri;
  font-size: 18px;
}

.content-bg {
  background: #eee;
}

.my-panel p {
  padding: 20px 0;
  height: 50px;
  border: 0;
  border-bottom: 1px solid #eee;
  font-family: Calibri;
  font-size: 18px;
}

.my-panel p:last-child {
  border-bottom: none;
}

.panel-body.my-panel-body {
  padding: 0 15px;
}

.number {
  float: right;
}

.panel-title {
  font-family: Calibri;
  font-size: 18px;
  text-transform: uppercase;
}

.order-sec {
  margin: 50px 0;
}

g.raphael-group-153-creditgroup tspan {
  display: none;
}

@media screen and (max-width: 767px) {
  .card {
    margin: 25px 0;
  }
  .custom-card{
    width: 100% !important;
  }
  .searchproj .justify-content-end {
    display: flex !important;
    justify-content: flex-start !important;
    width: 100%;
}
div#example_filter {
  width: 100% !important;
  display: block !important;
}
.list_label{
  width: 100%;
}
:where(.css-dev-only-do-not-override-1c0na6j).ant-picker{
  width: 100%;
}
}

.heading {
  font-size: 23px;
  border-bottom: 1px solid #c5c5c5;
  margin: 0 0 0px -19px;
  padding: 18px 20px 12px 19px;
  color: #000;
  background: #ffff;
  box-shadow: 0 0 5px #d0d0d0;
  position: fixed;
  width: calc(100% - 228px) !important;
  top: 0;
  text-shadow: 0 1px 0 #fff;
  /* text-transform: uppercase; */
  z-index: 1000;
}

@media (min-width: 992px) {
  .col-md-6 {
    width: 50%;
  }
}

.logotxt-admin1 {
  color: green;
  font-weight: 700;
  font-size: 29px;
}

.heading i {
  font-size: 20px;
  margin-right: 4px;
}

.fa {
  display: inline-block;
  font: normal normal normal 14px / 1 FontAwesome;
  font-size: inherit;
  text-rendering: auto;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.logotxt-admin2 {
  color: #878787;
  font-weight: 700;
  font-size: 29px;
}

.contacts-details-section,
.sops-details-section,
.site-visit-details-section,
.warehouse-details-section,
.products-details-section {
  padding: 0;
}

.admin .form-group .form-control {
  border: 1px solid #ccc;
  border-radius: 4px !important;
  font-size: 14px !important;
  font-family: "Blogger Sans" !important;
  color: #121212;
}

.admin .form-label-title {
  line-height: 1.25;
  color: #5c5c5c;
  margin-bottom: 8px;
  font-weight: 400;
  font-family: "Blogger Sans" !important;
}

.admin {
  border: 1px solid #ccc;
  border-radius: 4px !important;
  position: relative;
  margin-bottom: 60px;
}

.form-footer-main {
  text-align: right;
  margin-top: 0;
}

.tabs-steps-group h4 {
  font-size: 16px;
  font-weight: 400;
  margin-top: 20px;
  margin-bottom: 0;
  color: #878787;
  line-height: 1.2;
  margin-right: 60px;
  font-family: "Blogger Sans" !important;
}

.regulatory-contact-details-section .tabs-edits-section .form-label-title {
  line-height: 1.25;
  color: #5c5c5c;
  margin-bottom: 8px;
  font-weight: 400;
  font-family: BloggerSans;
}

.which-type-test {
  display: inline-block;
  width: 18px;
  height: 18px;
  border: 2px solid #878787;
  border-radius: 50%;
  font-size: 14px;
  line-height: 1;
  padding: 0 5px;
  font-weight: 700;
  margin-left: 0;
  position: relative;
  top: 0;
  cursor: pointer;
}

@media screen and (min-width: 1024px) {

  .sops-radio-group,
  .sops-title-group {
    position: relative;
    top: -4px;
    text-align: right;
  }
}

.agreement-point-section li {
  color: #5c5c5c;
  font-size: 16px;
  line-height: 1.35;
  margin-bottom: 30px;
  font-family: "Blogger Sans" !important;
}

.agreement-details-section {
  padding: 0;
}

button.btn.btn-success.btn-search {
  display: block;
  margin-top: 5px;
}

.btn-search {
  background-color: green;
  border-color: green;
  color: #fff;
}

.custom-col {
  /* width: 50%; */
  /* float: left; */
  padding: 15px;
}

.custom-card {
  width: 350px;
  background-color: #fff;
  border: 1px solid #ddd;
  border-radius: 4px !important;
  padding: 30px;
  box-shadow: 0 2px 5px #0000001a;
}

.custom-media {
  display: flex;
  align-items: center;
}

.custom-media-left {
  margin-right: 20px;
}

.custom-media-middle {
  vertical-align: middle;
}

.custom-icon {
  font-size: 40px;
  color: green;
}

.text-align-end {
  text-align: right;
}

.custom-media-body h2 {
  font-size: 24px;
  margin-bottom: 10px;
}

.custom-media-body p {
  margin-bottom: 0;
}

.content-bg {
  background: #eee;
}

.order-sec {
  display: flex;
  flex-wrap: wrap;
}
.sidebar-header.border-top {
  position: fixed;
  bottom: 0;
  width: 210px;
}
/* .order-sec>div {
  flex-basis: 100%;
} */

/* @media (min-width: 768px) {
  .order-sec>div {
    flex-basis: 50%;
  }
}

@media (min-width: 992px) {
  .order-sec>div {
    flex-basis: 50%;
  }
}

@media (min-width: 1200px) {
  .order-sec>div {
    flex-basis: 50%;
  }
}
}  */

.loaddata {
  font-family: "Blogger Sans" !important;
  font-size: 14px;
  font-weight: 600;
  text-align: left;
  color: #9d4740;
  display: block;
}

.tbl-cell {
  height: 100vh;
}

.readmore {
  color: #fff;
  background: green;
  padding: 12px 25px;
  border-radius: 50px;
  font-family: "Blogger Sans" !important;
  font-weight: 400 !important;
  text-decoration: none;
  width: 109px !important;
}

.contentwrapper .titlelable {
  color: #626262;
  font-size: 22px;
  margin-top: 20px;
}

.btn-xs,
.btn-group-xs>.btn {
  padding: 1px 5px !important;
  font-size: 12px;
  line-height: 1.5;
  border-radius: 4px !important;
}

.main-title {
  font-size: 22px !important;
  margin-bottom: 10px !important;
  margin-top: 30px !important;
  font-weight: 600 !important;
  color: #5c5c5c !important;
}

textarea,
select,
input {
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px !important;
  color: #5c5c5c;
  outline: none;
  background-color: #fff;
  border: 1px solid #cacaca;
  padding: 5px;
  line-height: 16px;
}

select {
  padding: 3px;
  font-family: "BloggerSans";
}

ul {
  margin: 0;
  padding: 0;
  font-family: "BloggerSans";
}

form {
  display: inline;
}

img {
  border: 0;
  outline: none;
}

a.nolink:hover {
  cursor: default;
  text-decoration: none;
}

span.clear {
  display: block;
  clear: both;
  width: 1px;
  height: 0.001%;
  font-size: 0;
  line-height: 0;
}

.clear {
  clear: both;
}

img {
  border: 0;
}

.tbl {
  display: table;
  width: 100%;
}

.tbl-row {
  display: table-row;
}

.tbl-cell {
  display: table-cell;
  vertical-align: top;
}

h1,
h2,
h3 {
  margin: 0;
  padding: 0;
}

a:focus {
  outline: none;
}

.row .btn:focus {
  outline: none;
}

.wrapper {
  height: 100%;
}

.wrapper_login {
  height: 100%;
  display: table;
  width: 100%;
}

.login {
  height: 100%;
  display: table-cell;
  vertical-align: middle;
  text-align: center;
}

.loginbox .logo {
  margin: 0 0 10px;
}

.loginbox .tbl {
  border: 1px solid #c5c5c5;
  background: #fff;
  width: 300px;
  margin: 0 auto;
  padding: 30px 20px;
  box-shadow: 0 0 5px #d0d0d0;
}

.loginbox .tbl .tbl-cell {
  padding: 7px;
  vertical-align: middle;
  text-align: left;
}

.loginbox .tbl .tbl-cell.col01 {
  width: 70px;
}

.loginbox .tbl .tbl-cell.col02 .textbox {
  width: 200px;
}

.submit {
  padding: 6px 10px 7px;
  background: #ea492f;
  color: #fff;
  border: 0;
  font-weight: 700;
  text-transform: uppercase;
  cursor: pointer;
}

.submitboot {
  padding: 0;
  margin: 0;
  background: none;
  border: none;
}

.input-group-addon.red {
  background: #ea492f;
  color: #fff;
  border: 1px solid #ea492f;
}

.input-group-addon.green {
  background: #007301;
  color: #fff;
  border: 1px solid #007301;
}

.input-group-addon.black {
  background: #222;
  color: #fff;
  border: 1px solid #222;
  font-weight: 700;
  border-radius: 4px !important;
}

.input-group-addon.green a {
  color: #fff;
}

.input-group-addon.black a {
  color: #fff;
  font-weight: 700;
}

.msg {
  color: #007301;
  margin: 10px 0;
  font-size: 18px;
}

.msg.error {
  color: #ea492f;
}

.wrapper .tbl.homepage {
  height: 100%;
  display: table;
  width: 100%;
}

.wrapper .homepage .tbl-cell.leftbar {
  border-right: 1px solid #b7b7b7;
  width: 210px;
  background: #fff;
  box-shadow: 0 0 5px #b7b7b7;
  position: fixed;
  height: 100%;
  z-index: 1;
}

.leftbar .logom {
  border-bottom: 1px solid #f3f3f3;
  margin: 0 0 20px;
}

.leftbar .logom img {
  max-width: 150px;
}

.menu a {
  display: block;
  padding: 7px 0 7px 15px;
  font-size: 14px;
  margin: 5px 0;
  color: #373737;
}

.menu a.active,
.menu a:hover {
  color: #ea4a30;
}

.menu a.sep {
  border-top: 1px solid #f0f0f0;
  margin: 20px 0 0;
}

.menu a i {
  padding: 0 5px 0 0;
  font-size: 17px;
}

.wrapper .homepage .tbl-cell.content {
  padding: 80px 50px 0 0;
  text-align: left;
}

.heading i {
  font-size: 20px;
}

.chpass {
  border: 1px solid #c5c5c5;
  background: #fff;
  max-width: 600px;
  padding: 30px 20px;
  box-shadow: 0 0 5px #d0d0d0;
}

.chpass .tbl .tbl-cell {
  padding: 7px;
  vertical-align: middle;
  text-align: left;
}

.chpass .tbl .tbl-cell.col01 {
  width: 150px;
}

.chpass .tbl .tbl-cell.col02 .textbox {
  width: 200px;
}

.searchproj {
  margin: 60px 0 10px;
}

.searchproj .textbox {
  width: 60%;
  padding: 5px 6px 7px;
}

.pagination {
  margin: 10px 0 50px;
  padding: 10px;
  text-align: center;
}

.pagination a {
  padding: 1px 8px;
  background: #fff;
}

.pagination a.selected {
  background: #000;
  color: #fff;
}

.tbl-row .tbl-cell {
  padding: 5px 0;
}

.tbl-row .tbl-cell.col01 {
  width: 80px;
}

.file {
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  width: 100%;
}

.datalist {
  background: #fff;
}

.datalist .tbl-row.fldname {
  background: #f2f2f2;
  font-weight: 700;
  font-size: 17px;
  color: #000;
}

.datalist .tbl-row .tbl-cell {
  padding: 10px;
  vertical-align: middle;
}

.datalist .datalistrow .tbl-cell {
  border-top: 1px dashed #dfdfdf;
}

.datalist .datalistrow.fst .tbl-cell {
  border: none;
}

.datalist.banner_list .tbl-row .tbl-cell.col01 {
  width: 70px;
  text-align: center;
}

.datalist.banner_list .tbl-row .tbl-cell.col02 {
  width: 170px;
  text-align: center;
}

.datalist.banner_list .tbl-row .tbl-cell.col03 {
  text-align: left;
}

.datalist.banner_list .tbl-row .tbl-cell.col04 {
  width: 150px;
  text-align: center;
}

.datalist.banner_list .tbl-row .tbl-cell.col05 {
  width: 100px;
  text-align: center;
}

.datalist.banner_list img {
  width: 150px;
  height: 75px;
  padding: 1px;
  border: 1px solid #c2c2c2;
}

.datalist.banner_list .datalist .tbl-cell.col03 {
  font-size: 13px;
}

.datalist.banner_list .tbl-cell.col03 strong {
  font-size: 20px;
  display: block;
}

.datalist.banner_list .actn a {
  display: block;
  margin: 5px 0;
}

.datalist.projectlist .tbl-row .tbl-cell.col01 {
  width: 70px;
  text-align: center;
}

.datalist.projectlist .tbl-row .tbl-cell.col02 {
  width: 100px;
  text-align: center;
}

.datalist.projectlist .tbl-row .tbl-cell.col04 {
  width: 100px;
  text-align: center;
}

.datalist.projectlist .tbl-row .tbl-cell.col05 {
  width: 150px;
  text-align: center;
}

.datalist.projectlist .tbl-row .tbl-cell.col06 {
  width: 150px;
  text-align: center;
}

.datalist.projectlist .datalist .tbl-cell.col03 {
  font-size: 13px;
}

.datalist.projectlist .tbl-cell.col03 strong {
  font-size: 20px;
  display: block;
}

.datalist.projectlist .tbl-row .tbl-cell.col06 .yes {
  color: #008601;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
}

.datalist.projectlist .tbl-row .tbl-cell.col06 .no {
  color: #f11;
  font-weight: 700;
  letter-spacing: 1px;
  cursor: pointer;
}

a.bacllink {
  text-transform: uppercase;
}

a.bacllink i {
  font-size: 12px;
}

.validate_error {
  color: #d95c5c;
  margin: 10px 0;
  display: none;
  font-weight: 600;
}

/* .bvalidator_invalid {
  color: #d95c5c;
}

.bvalidator_invalid::-webkit-input-placeholder {
  color: #d95c5c;
  font-size: 14px;
}

.bvalidator_invalid:-moz-placeholder {
  color: #d95c5c;
  opacity: 1;
  font-size: 14px;
}

.bvalidator_invalid::-moz-placeholder {
  color: #d95c5c;
  opacity: 1;
  font-size: 14px;
}

.bvalidator_invalid:-ms-input-placeholder {
  color: #d95c5c;
  font-size: 14px;
} */

textarea {
  resize: none;
}

.tbl .tblcell {
  display: table-cell;
  vertical-align: top;
}

/* .leftpanel {
  border: 0 solid #cfcfcf;
  box-shadow: 0 0 0 #dedede;
  padding: 0;
} */

.formfield .fieldlitbl {
  margin: 20px 0 0;
}

.formfield .fieldlitbl.tbl .tblcell.col01 {
  width: 200px;
  font-family: Calibri;
}

.addnew .tbl .tblcell.col01 {
  font-weight: 600;
  vertical-align: middle;
}

.rightpanel {
  padding: 0 0 0 70px;
  width: 400px;
}



.form-control.mb {
  margin: 0 0 10px;
}


/* .media_show {
  border: 1px solid;
  float: left;
  margin: 4px 5px 50px 0;
  max-width: 92px;
  height: 75px;
  width: 92px;
}

.media_show img {
  height: 70px;
  width: 100%;
} */

.btn_add {
  padding-left: 40px;
}

.table_heading {
  font-size: 16px;
}

.ui-menu-item {
  background-color: #fff !important;
  background-image: none !important;
  border-radius: 4px !important;
  color: #555 !important;
  display: block !important;
  font-size: 14px !important;
  height: 34px !important;
  line-height: 1.42857 !important;
  padding: 6px 12px !important;
  transition:
    border-color 0.15s ease-in-out 0s,
    box-shadow 0.15s ease-in-out 0s !important;
  width: 100% !important;
}

.ui-state-hover,
.ui-widget-content .ui-state-hover,
.ui-widget-header .ui-state-hover,
.ui-state-focus,
.ui-widget-content .ui-state-focus,
.ui-widget-header .ui-state-focus {
  background: #ececec !important;
  font-weight: 400 !important;
  color: #212121 !important;
}

.media_checkbox {
  float: left;
  margin: 10px 0 0;
  font-weight: 700;
}

.userdiv {
  margin: 0 0 20px;
}

.btn:hover,
.btn:focus,
.btn.focus {
  color: #fff !important;
  text-decoration: none;
}

.btn_r:hover,
.btn_r:focus,
.btn_r.focus {
  color: #000 !important;
  text-decoration: none;
  cursor: default;
}

.productoutofstock {
  opacity: 0.4;
}

.errmsg {
  color: #bd3400;
  font-weight: 300;
  z-index: 1;
}

.logotxt1 {
  color: green;
  font-weight: 700;
  font-size: 35px;
}

.logotxt2 {
  color: #878787;
  font-weight: 700;
  font-size: 35px;
}

.datatextcnt {
  text-align: center;
}

.fa.fa-pencil,
.fa.fa-trash-o,
.fa.fa-envelope,
.fa.fa-eye,
.fa.fa-check {
  color: #ae0000;
}

.deselect_address {
  color: #ae0000;
  cursor: pointer;
  display: block;
  font-weight: 600;
}

.ordertab {
  padding: 0;
}

.dropdown-menu>li>a {
  clear: both;
  color: grey !important;
  display: block;
  font-size: 17px !important;
  font-weight: 300;
  line-height: 2 !important;
  padding: 3px 20px;
  white-space: nowrap;
  font-family: "BloggerSans";
}

.dropdown-menu {
  border-radius: 1px !important;
  width: 84%;
}

.container .logotext {
  padding: 0;
  color: #fff;
  font-family: "BloggerSans";
  font-size: 14px;
  width: 20%;
}

.serachicon {
  display: inline-flex;
}

.main-section {
  height: auto;
  padding-bottom: 25px;
}

.order-productpricelist a {
  font-size: 20px;
  color: #fff;
}

.order-productpricelist a:hover {
  font-size: 20px !important;
  color: #fff;
}

.input-group-addon {
  background-color: green !important;
  color: #fff;
  border: 1px solid green;
}

.dropdown ul li {
  display: inline;
}

.fltright {
  float: right;
}

.pharmacontaner {
  padding: 0;
}

.shippinglable {
  font-size: 18px;
  font-weight: 700;
  padding: 0 0 10px 23px;
}

/* .patientlable {
  font-size: 20px;
  font-weight: 700;
  padding: 0 0 10px;
} */

.deliverybtn {
  padding-top: 10px;
  width: 376px;
}

.deliverybtn-orderconfirm {
  padding-top: 10px;
}

.shippingadd {
  padding-right: 10px;
  padding-left: 10px;
  padding-bottom: 60px;
}

.newshippingadd {
  color: green;
  cursor: pointer;
  font-size: 15px;
  font-weight: 700;
  margin: 25px 0 10px 25px;
}

.paymentnone {
  display: none;
}

.proddiv .totalpricelable {
  padding: 10px;
  float: right;
}

.sp-quantity {
  width: 124px;
  height: 42px;
  font-family: "ProximaNova Bold", Helvetica, Arial;
}

.sp-minus {
  width: 40px;
  height: 35px;
  border: 1px solid green;
  float: left;
  text-align: center;
  color: green;
}

.sp-plus {
  width: 40px;
  height: 35px;
  border: 1px solid green;
  border-left: 0 solid #e1e1e1;
  float: left;
  text-align: center;
  color: green;
}

.sp-minus a,
.sp-plus a {
  display: block;
  width: 100%;
  height: 100%;
  padding-top: 5px;
}

.ajax-loader {
  visibility: hidden;
  background-color: #ffffffb3;
  position: absolute;
  z-index: 100 !important;
  width: 100%;
  height: 100%;
}

.ajax-loader img {
  position: relative;
  top: 50%;
  left: 50%;
}

.ajax-loader-body {
  visibility: hidden;
  background-color: #ffffffb3;
  position: absolute;
  z-index: 100 !important;
  width: 100%;
  height: 100%;
}

.ajax-loader-body img {
  position: relative;
  top: 50%;
  left: 50%;
}

#exTab2 {
  padding: 80px;
}

#exTab2 h3 {
  color: #fff;
  background-color: #428bca;
  padding: 5px 15px;
}

.order-list a:hover {
  color: green;
}

.grey {
  color: #666 !important;
}

.grey:hover {
  color: #222 !important;
}



.all-item-info>a:hover {
  color: #000 !important;
}


.pending-order-list {
  padding-bottom: 20px;
}

.order-productpic {
  vertical-align: top;
}

.topheader {
  height: 36px;
  background: #000;
}

.nopadding {
  padding-left: 0;
  padding-right: 0;
}

.leftpadding {
  padding-left: 0;
}

.rightpadding {
  padding-right: 0;
}

.searchstr {
  padding: 25px 0 20px 25px;
  color: #fff;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 26px;
}

.btn-searchbox {
  background: #ecffec;
  font-size: 20px;
  color: #000;
  font-family: Verdana, Segoe, sans-serif;
  font-weight: 700;
}


.middlesect {
  padding-top: 30px;
}


.btn-yellow {
  background-color: #f0bf1a;
  border-color: #7d7b7b;
  color: #222;
  padding: 9px;
  font-size: 13px;
  width: 116px;
  font-weight: 700;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  float: right;
  display: inline-block;
}

.btn-red {
  background-color: #fa8072;
  border-color: #7d7b7b;
  color: #222;
  padding: 9px;
  font-size: 13px;
  width: 116px;
  font-weight: 700;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  float: right;
  display: inline-block;
}

.addcartsect {
  vertical-align: top;
  float: right;
  padding: 30px;
}


input[type="number"]::-webkit-outer-spin-button,
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type="number"] {
  -moz-appearance: textfield;
}

.form-control::-moz-placeholder {
  color: #a0a0a0 !important;
  font-family: Arial, Helvetica, sans-serif;
}


.paddingbottom50 {
  padding-bottom: 50px;
}

.orderconfirmationbtn {
  text-align: center;
  margin: 0 auto;
  width: 450px;
}

.pointcls {
  cursor: pointer;
}

.btn-srch {
  background-color: #007500;
  border-color: #007500;
  color: #fff;
  height: 45px;
}

.searchbrd {
  border-color: #007500;
  height: 45px;
}

.form-control-calender {
  display: block;
  height: 34px;
  line-height: 34px;
  pointer-events: none;
  position: absolute;
  right: 15px;
  text-align: center;
  top: 0;
  width: 34px;
  z-index: 2;
}

.patient-name-lable {
  color: green;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 22px;
  padding-left: 10px;
}

.patient-add-lable {
  color: #777;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 14px;
  padding: 5px 0 0 10px;
  display: block;
}

.patientchkdiv {
  vertical-align: top;
  float: left;
  margin-top: -10px;
}

.patientactionbdiv {
  vertical-align: top;
  float: right;
}

.patientactionbdiv .fa.fa-pencil {
  color: grey;
}

.patientactionbdiv .fa.fa-pencil:hover {
  color: #000;
}


.checkbox input[type="checkbox"] {
  display: none;
}

.checkbox label input[type="checkbox"]+.cr>.cr-icon {
  opacity: 0;
  transform: scale(3) rotateZ(-20deg);
  transition: all 0.3s ease-in 0s;
}


.checkbox label input[type="checkbox"]:checked+.cr>.cr-icon {
  opacity: 1;
  transform: scale(1) rotateZ(0deg);
}

.checkbox label {
  cursor: pointer;
  font-weight: 400;
  padding-left: 12px;
}

.backbtn {
  color: grey;
  font-size: 26px;
  float: left;
}

.backbtn:hover {
  color: #222;
  font-size: 26px !important;
  float: left;
}

.nextbtn {
  color: grey;
  font-size: 26px;
  float: right;
}

.nextbtn:hover {
  color: #222;
  font-size: 26px !important;
  float: right;
}

.no-visibility {
  visibility: hidden;
}

.ui-dialog .ui-dialog-titlebar-close {
  display: none !important;
}

.ui-widget.ui-widget-content {
  border: 1px solid green !important;
}

.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.order-checkout:active,
.order-checkout.ui-state-active:hover {
  background: green !important;
  border: 1px solid green;
}

.ui-dialog .ui-dialog-buttonpane {
  border: 0 !important;
  margin-top: -10px !important;
}

.ui-widget-content .ui-state-active,
.ui-widget-header .ui-state-active,
a.ui-button:active,
.grey:active,
.grey.ui-state-active:hover {
  background: #e9e9e9 !important;
  border: 1px solid #e9e9e9;
  color: #222 !important;
}

.order-success-msg {
  font-size: 22px;
  color: green;
  font-family: Arial, Helvetica, sans-serif;
}

.gopage {
  font-size: 22px;
  color: gray;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 35px;
  float: left;
}

.gopage:hover {
  font-size: 22px !important;
  color: #00f;
  font-family: Arial, Helvetica, sans-serif;
  margin-top: 35px;
  float: left;
}

.btn-grey {
  background-color: #eceef0;
  border: 1px solid #adb1b8;
  color: #222;
}

.btn-next {
  background-color: green;
  color: #fff;
  width: 30%;
  font-family: Arial, Helvetica, sans-serif;
}

.btn-next:hover,
.btn-next:focus {
  background-color: green;
  color: #fff !important;
  width: 30%;
  font-family: Arial, Helvetica, sans-serif;
}

.submit-btn {
  display: inline;
  position: relative;
  left: 30%;
  top: 25px;
}



.contentwrapper .titlelable {
  color: #626262;
  font-size: 22px;
  margin-top: 40px;
}

.table-responsive {
  overflow-x: inherit;
}

.patient-dl {
  padding-left: 65px;
  padding-top: 25px;
}

.order-pricesect {
  vertical-align: top !important;
  float: right;
}

.order-vatpercentage {
  color: grey;
  float: left;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 17px;
  font-weight: 700;
  margin: 20px 0 0 10px;
}

.row.order-totalprice {
  padding-bottom: 20px;
}

.order-lablevalue {
  color: grey;
  float: right;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 22px;
  font-weight: 400;
  margin: 20px 35px 0 0;
}

.order-totaldue {
  color: #007f00;
  float: left;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 17px;
  font-weight: 700;
  margin: 20px 0 0 10px;
}

/* .order-totalvalue {
  color: #007f00;
  float: right;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 22px;
  font-weight: 400;
  margin: 20px 35px 0 0;
} */

/* .order-patientlable {
  color: #000;
  font-family: Tahoma, Verdana, Segoe, sans-serif;
  font-size: 23px;
  padding-bottom: 20px;
  padding-top: 40px;
} */

.patient-dl li {
  width: 100%;
}

.print_pdf {
  font-weight: 700;
  padding: 5px;
  border: 1px solid;
  float: right;
}

.producttable {
  position: relative;
}

@media screen and (min-width: 769px) {
  .brandsection {
    position: absolute;
    right: 0;
  }
}

@media screen and (max-width: 768px) {
  .brandrow {
    display: flex;
    margin-bottom: 14px;
    width: 100%;
  }

  .brandbox {
    width: 50%;
  }

  .searchbox {
    width: 50%;
  }
}

.leftbar {
  width: 220px !important;
  background-color: #f8f9fa;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.logom {
  padding: 20px;
  text-align: center;
}

.menu {
  padding: 10px;
  font-size: 16px;
}

.menu-item {
  margin-bottom: 10px;
}

.submenu {
  margin-left: 20px;
}

.menu a {
  display: block;
  padding: 10px;
  color: #333;
  text-decoration: none;
  font-size: 16px !important;
}

.menu a:hover {
  background-color: #e9ecef;
  font-size: 16px;
}

.sep {
  cursor: pointer;
}

.leftbar a {
  text-decoration: none;
  cursor: pointer;
  outline: none;
  color: #5c5c5c;
  font-size: 15px;
  margin-bottom: 6px;
}

.active {
  border: none;
}

.dashboard-wrapper {
  display: flex;
}

.content-wrapper {
  padding: 20px;
  width: calc(100% - 220px);
}

.custom-col {
  /* flex: 1; */
  margin-bottom: 20px;
}

.custom-media {
  display: flex;
  align-items: center;
}

.custom-media-left {
  margin-right: 25px;
}

.custom-icon {
  font-size: 24px;
}

.custom-media-body {
  flex: 1 1;
}

.m-b-0 {
  margin-bottom: 0;
}

.details-card {
  margin-top: 100px;
}

.details-table {
  font-size: 15px;
  font-weight: 500;
}

.table th {
  border: none !important;
}


.navbar .nav li a {
  font-family: "Blogger Sans"!important;
  font-size: 15px !important;
  color: #008000 !important;
  font-weight: 300;
}

.news-second-row {
  margin-top: 50px !important;
}


.list_label {
  font-size: 14px;
  font-weight: 500;
}

.owl-theme .owl-nav [class*=owl-] {
  color: #FFF;
  font-size: 14px;
  margin: 5px;
  padding: 4px 7px;
  display: inline-block;
  cursor: pointer;
  border: none;
  background-color: #FFF;
}



.background-container {
  width: 100%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
  background-size: cover;
}

.form-container {
  position: relative;
  z-index: 1;
  padding: 20px;
  border-radius: 8px;
}


.sidebar-nav .nav-link.active {
  color: #fff !important;
  width: 197px !important;
  background: #008000 !important;
}

.sidebar-nav .nav-link:hover {
  color: #fff;
  width: 197px !important;
  background: #008000;
}

.terms_condination_model {
  height: 490px !important;
}





.details-table {
  table-layout: fixed;
  /* Ensures columns are of consistent width */
  width: 100%;
  /* Makes the table use the full width of its container */
}

.details-table th,
.details-table td {
  max-width: 200px;
  /* Adjust as needed for your design */
  overflow: hidden;
  /* Hides overflowing content */
  text-overflow: ellipsis;
  /* Adds ellipsis if text overflows */
  padding: 8px;
  /* Adds padding to cells */
  vertical-align: middle;
  /* Vertically aligns text */
}

.details-table th {
  background-color: #f8f9fa;
  /* Light grey background for headers */
  text-align: left;
  /* Aligns header text to the left */
}


.ant-spin-dot-holder {
  color: #008000 !important;
}
@media screen and (max-width: 767px) {
  a#system_mobile_menu_toggler i {
    color: #fff;
}
  div#example_filter .list_label input {
    width: 100% !important;
    display: block;
}
  .order-sec{
    margin: 0;
  }
  .custom-col{
    padding: 15px 0;
    margin-bottom: 0;
    width: 100% !important;
  }
  .searchproj{
    margin-top: 30px;
  }
  .custom-media-left {
    margin-right: 35px;
  }
  .heading{
    position: relative !important;
    top: unset !important;
    margin: 0 !important;
    padding: 10px 15px !important;
    font-size: 20px !important;
    width: 100%!important;
  }
  .sidebar-nav .nav-link:hover{
    width: 100% !important;
  }
  .sidebar-header.border-top {
    display: none;
}
  .nav-group-items{
    display: flex !important;
    flex-direction: column;
  }
  .btn_back{
    margin-right: 0px !important;
  }
  .hdr_sec{
    width: 100%!important;
    margin-top: 60px !important;
  }
  #system_sidebar_id{
    display: none;
  }
  .system_sidebar_active {
    display: block !important;
    width: 100%;
    position: absolute;
    top: 60px;
    left: 0;
    z-index: 999;
    background: #333333 !important;
}
.mobile-menu-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 10px 20px;
  height: 100%;
  background: #333333 !important;
}
  .mobile-menu.md\\:hidden {
    display: flex !important;
}
.sidebar.sidebar-dark.leftbar {
  width: 100% !important;
  margin-left: 0px !important;
  height: max-content !important;
}
.sidebar-header.border-bottom {
  display: none;
}
  .sidebar:not(.sidebar-end):not(.show){
    margin-left: 0;
  }
  .col-md-3.service4 {
    margin-top: 40px;
  }
  .service-image_new img {
    max-width: 100%;
    height: 152px;
    border-radius: 100%;
    border: 1px solid green;
    width: 152px;
  }
  .collapse.navbar-collapse.open-menu {
    display: block !important;
    position: absolute;
    background: #fff;
    width: 100%;
    z-index: 111;
    padding: 0;
    visibility: visible;
}
div#menubar .navbar-left li:hover {
  background: #008210;
}
  .collapse.navbar-collapse.open-menu ul{
    display: block !important;
  }
  ul.dropdown-menubar {
    left: 0;
  }
  .register-link-group a {
    margin: 0;
    width: 100%;
    margin-bottom: 30px;
  }

  .registerbox {
    width: 100%;
  }

  .register-link-group {
    display: flex;
    flex-wrap: wrap;
    gap: 19px;
  }

  .register-page-link {
    padding: 50px 0px;
  }

  .registerbox {
    text-align: center;
    margin: 0px;
    position: relative;
    width: 100%;
    height: 218px;
    border: 1px solid #989898;
    transition: 0.1s;
  }

  .registerbox h4 {
    margin-top: 35px;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.35;
  }

  .registerbox:hover h4 {
    color: #008000;
  }

  .registerbox a {
    color: #008000;
  }

  .register-link-group a {
    display: inline-block;
  }

  .registerbox .img-centered {
    margin-top: 40px;
  }

  .i-want-to-register {
    font-size: 17px !important;
    font-weight: 600;
    color: #008000;
    text-transform: uppercase;
    text-align: center;
    margin-bottom: 40px;
  }

  .company-details-section,
  .sops-details-section,
  .site-visit-details-section,
  .warehouse-details-section,
  .products-details-section {
    padding: 15px;
  }

  .contacts-details-section .row,
  .contacts-details-section .form-main-title,
  .contacts-details-section .form-footer-main,
  .regulatory-contact-details-section .row,
  .regulatory-contact-details-section .form-main-title,
  .regulatory-contact-details-section .form-footer-main {
    padding-left: 15px;
    padding-right: 15px;
  }

  .agreement-details-section .agreement-point-section,
  .agreement-details-section .form-main-title,
  .agreement-details-section .row,
  .agreement-details-section .form-body-title,
  .agreement-details-section .form-footer-main {
    padding-left: 15px;
    padding-right: 15px;
  }

  ul.righ-bar-menu .contact-menu {
    padding-left: 0;
  }

  span.dropdown-toggle {
    padding-left: 0;
    padding-right: 0;
  }

  .hdr-social {
    text-align: center;
    margin: 10px 16px 20px;
  }

  .viruses-text {
    padding: 0;
  }

  .destroy-viruses-section {
    padding: 50px 0;
    margin-bottom: 50px;
  }

  .microoragnisms-content-section {
    margin: 15px;
  }

  .microoragnisms-section {
    padding-bottom: 50px;
  }

  h2.title-odorless {
    font-size: 30px;
    width: 100%;
    line-height: 35px;
  }

  .odorless-section {
    position: relative;
    padding: 50px 0;
  }

  p.title-ozone-renew {
    width: 100%;
    margin: 20px auto 40px;
  }

  img.img-odorless {
    width: 100%;
    margin: 0 auto 20px;
  }
  p.anti-inflammatory:after {
    right: unset;
    left: 0;
  }

  .additives p {
    font-size: 22px;
    line-height: 30px;
    font-family: "Blogger Sans" !important;
  }

  .product-features-section {
    margin-bottom: 50px;
  }

  .microoragnisms-text {
    margin-top: 30px;
  }

  .microoragnisms-text h2,
  h4 {
    font-size: 22px;
    font-family: "Blogger Sans" !important;
  }

  .bacteria-title {
    margin-top: 10px;
  }

  .bacteria-col {
    margin-top: 30px;
  }
  #servicetxt h4{
    text-align: center;
    margin-top: 20px;
  }
  .servicedv h1{
    font-size: 30px;
  }
}
/* Hetal Css Start */
.overflow-x-h {
  overflow-x: hidden;
}
.servicedv h1{
  font-family: "Blogger Sans";
  margin-bottom: 15px;
}
ul.nav.navbar-nav.navbar-left.menu_margin{
  margin-bottom: 8px;
}
nav.navbar li.hover-dropdown ul.dropdown-menubar li:hover a{
  color: #fff;
  padding: 0;
}
nav.navbar li.hover-dropdown ul.dropdown-menubar li:hover{
  background: #008000;
}
ul.dropdown-menubar{
  right: 0;
}
.service-hr {
  color: #ccc;
  margin-bottom: 15px;
  margin-top: 15px;
}
.mobile-menu.md\\:hidden {
  display: none;
}
.servicesrow .text-muted {
  min-height: 140px;
  font-size: 14px !important;
  font-family: "Blogger Sans" !important;
  font-weight: 300 !important;
}
strong{
  font-weight: 500 !important;
}
.news-title{
  font-family: "Blogger Sans";
}
.btn-continue-reading{
  font-weight: 500;
  font-family: "Blogger Sans";
}
li.hover-dropdown.login-dropdown a {
  font-family: "Blogger Sans";
  font-weight: 300;
}
.hdr_sec{
  width: calc(100% - 213px);
  display: block;
}
.sidebar-nav .nav-link{
  font-family: "Blogger Sans";
  font-size: 14px;
  font-weight: 300;
}
.left_col{
  min-height: 65px;
}
.sidebar-nav .nav-link:hover{
  background: #008000 !important;
}
a.sidebar-brand {
  margin-bottom: 0;
}
.checkbox .cr .cr-icon {
  color: #008000;
  font-size: 22px;
  left: -10%;
  line-height: 0;
  position: absolute;
  top: 49%;
}
.btn_back{
  margin-right: 0px !important;
}
/* .step-content-body input::-webkit-datetime-edit-day-field,.step-content-body input::-webkit-datetime-edit-month-field,.step-content-body input::-webkit-datetime-edit-year-field,.step-content-body input::-webkit-datetime-edit-text {
  display: none;
} */
 input[type="date"]:focus + label,
 input[type="date"]:not(:placeholder-shown) + label {
    top: -12px;
    left: 8px;
    font-size: 12px;
    color: #007bff;
}
a.nav-link i {
  padding-right: 8px;
}
.btn_back_submit .btn_submit{
  margin-left: 10px;
}
.ant-table-cell, .ant-table-cell a{
  font-family: "Blogger Sans" !important;
}
span.ant-table-column-title {
  font-weight: 500;
}
/* Heather Css End */

`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,uBAAuB;EACvB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,6BAA6B;EAC7B,4BAA4B;AAC9B;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,yBAAyB;EACzB,qBAAqB;EACrB,2BAA2B;EAC3B,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,UAAU;EACV,SAAS;EACT,YAAY;EACZ,SAAS;EACT,UAAU;;AAEZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,0BAA0B;EAC1B,sCAAsC;;AAExC;;;AAGA;EACE,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,cAAc;EACd,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,+BAA+B;EAC/B,0BAA0B;EAC1B,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,WAAW;EACX,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gCAAgC;EAChC,iDAAiD;EACjD,uCAAuC;AACzC;;AAEA;EACE,gCAAgC;EAChC,uCAAuC;EACvC,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,2CAA2C;EAC3C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,MAAM;AACR;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;;;;EAKE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;;EAOE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU;EACV,UAAU;EACV,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;;EAME,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,SAAS;EACT,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;;;;;EAKE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;;;AAIA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;;;;;;;;;GAYG;;AAEH;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;;;;GAMG;;AAEH;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;;;EAGE,YAAY;AACd;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;;;;;;IAME,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;IAGE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;IACb,WAAW;EACb;;EAEA;IACE,UAAU;IACV,WAAW;EACb;;EAEA;IACE,aAAa;IACb,WAAW;EACb;AACF;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;IACE;QACI,WAAW;QACX,iBAAiB;QACjB,0BAA0B;IAC9B;EACF;IACE,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,UAAU;IACV,cAAc;IACd,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;;;EAGE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;;;;;KAOG;;EAEH;;;;;IAKE,aAAa;EACf;;EAEA;;;;;;IAME,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,kDAAkD;EACpD;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,kDAAkD;EACpD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;;AAGF;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,uBAAuB;EACvB,wCAAwC;EACxC,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qCAAqC;EACrC,sCAAsC;EACtC,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,sCAAsC;EACtC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,sCAAsC;EACtC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,sCAAsC;EACtC,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,6CAA6C;EAC7C,0BAA0B;EAC1B,cAAc;EACd,0BAA0B;EAC1B,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;;AAE5B;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,sCAAsC;EACtC,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,6BAA6B;EAC7B,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;;;AAGA;;EAEE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,2BAA2B;EAC3B,iBAAiB;EACjB,yBAAyB;EACzB,sBAAsB;EACtB,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,oCAAoC;EACpC,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,6BAA6B;EAC7B,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;IACxB,sCAAsC;IACtC,WAAW;AACf;AACA;EACE,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,qBAAqB;EACrB,4BAA4B;EAC5B,WAAW;EACX,iBAAiB;EACjB,2BAA2B;EAC3B,eAAe;EACf,oCAAoC;EACpC,MAAM;EACN,yBAAyB;EACzB,+BAA+B;EAC/B,aAAa;AACf;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,kBAAkB;EAClB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;EAKE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,0BAA0B;EAC1B,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,sBAAsB;EACtB,6BAA6B;EAC7B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,MAAM;EACN,eAAe;AACjB;;AAEA;;EAEE;;IAEE,kBAAkB;IAClB,SAAS;IACT,iBAAiB;EACnB;AACF;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;AACA;EACE,eAAe;EACf,SAAS;EACT,YAAY;AACd;AACA;;GAEG;;AAEH;;;;;;;;;;;;;;;;;IAiBI;;AAEJ;EACE,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,sCAAsC;EACtC,2BAA2B;EAC3B,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;EAC1B,8BAA8B;EAC9B,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;;EAGE,2DAA2D;EAC3D,0BAA0B;EAC1B,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,aAAa;AACf;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,UAAU;EACV,cAAc;EACd,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;EAGE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,YAAY;EACZ,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;EACf,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;GAwBG;;AAEH;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;;;;GAIG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;;;AAIA;EACE,gBAAgB;AAClB;;;AAGA;;;;;;;;;;;;GAYG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,iCAAiC;EACjC,6BAA6B;EAC7B,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B;;8CAE4C;EAC5C,sBAAsB;AACxB;;AAEA;;;;;;EAME,8BAA8B;EAC9B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;;EAGE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;EAKE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,0BAA0B;EAC1B,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;;GAIG;;AAEH;EACE,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;;;AAIA;EACE,sBAAsB;AACxB;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,uCAAuC;EACvC,gBAAgB;AAClB;;;AAGA;EACE,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,+CAA+C;EAC/C,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;;AAGA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,yCAAyC;AAC3C;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,yCAAyC;EACzC,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yCAAyC;EACzC,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,mCAAmC;EACnC,+BAA+B;AACjC;;;AAGA;EACE,UAAU;EACV,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;AACb;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;;AAEA;EACE,WAAW;EACX,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;;;;EAKE,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,4BAA4B;AAC9B;;AAEA;;;;;EAKE,8BAA8B;EAC9B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,WAAW;EACX,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,UAAU;EACV,yCAAyC;AAC3C;;AAEA;;EAEE,uBAAuB;EACvB,sBAAsB;EACtB,UAAU;EACV,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,SAAS;AACX;;;;AAIA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,+CAA+C;EAC/C,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;;;;;GAOG;;AAEH;;;;;;GAMG;;AAEH;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;EACV;AACF;;AAEA;EACE;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,aAAa;EACb,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;;AAGA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;;AAGA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;;;AAIA;EACE,WAAW;EACX,2EAA8F;EAC9F,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;;AAGA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;;;;;AAMA;EACE,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;EACX,wDAAwD;AAC1D;;AAEA;;EAEE,gBAAgB;EAChB,qCAAqC;EACrC,gBAAgB;EAChB,8BAA8B;EAC9B,uBAAuB;EACvB,oCAAoC;EACpC,YAAY;EACZ,0BAA0B;EAC1B,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,sCAAsC;EACtC,gBAAgB;EAChB,mCAAmC;AACrC;;;AAGA;EACE,yBAAyB;AAC3B;AACA;EACE;IACE,WAAW;AACf;EACE;IACE,sBAAsB;IACtB,cAAc;AAClB;EACE;IACE,SAAS;EACX;EACA;IACE,eAAe;IACf,gBAAgB;IAChB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,6BAA6B;IAC7B,qBAAqB;IACrB,oBAAoB;IACpB,6BAA6B;IAC7B,0BAA0B;IAC1B,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,aAAa;AACjB;EACE;IACE,wBAAwB;IACxB,sBAAsB;EACxB;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;IACrB,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,YAAY;IACZ,8BAA8B;AAClC;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;EACE;IACE,wBAAwB;AAC5B;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;EACE;IACE,cAAc;EAChB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;EACd;EACA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,mBAAmB;AACvB;AACA;EACE,mBAAmB;AACrB;EACE;IACE,yBAAyB;EAC3B;EACA;IACE,OAAO;EACT;EACA;IACE,SAAS;IACT,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,eAAe;IACf,SAAS;EACX;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;;;;;;IAME,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;;;;;IAKE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,OAAO;EACT;;EAEA;IACE,eAAe;IACf,iBAAiB;IACjB,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,sCAAsC;EACxC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;AACF;AACA,oBAAoB;AACpB;EACE,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;AACV;AACA;EACE,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,sCAAsC;EACtC,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,4BAA4B;AAC9B;AACA;;GAEG;CACF;;IAEG,UAAU;IACV,SAAS;IACT,eAAe;IACf,cAAc;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,gBAAgB;AAClB;AACA,oBAAoB","sourcesContent":["html,\nbody {\n  height: 100% !important;\n  margin: 0;\n  overflow: auto;\n}\n\n.container {\n  padding-right: 15px !important;\n  padding-left: 15px !important;\n  margin-right: auto !important;\n  margin-left: auto !important;\n}\nbody {\n  height: 100%;\n  margin: 0 !important;\n  font-size: 14px !important;\n  font-style: normal;\n  color: #5c5c5c !important;\n  text-decoration: none;\n  font-weight: 300 !important;\n  background: #fff;\n  font-family: \"Blogger Sans\" !important;\n}\n\nul li {\n  list-style-type: none;\n}\n\n.top-header {\n  padding: 10px 0;\n  position: relative;\n  box-shadow: 0 0 4px 0 #ccc;\n}\n\nul.left-bar-menu {\n  padding: 0;\n  margin: 0;\n  float: right;\n  margin: 0;\n  padding: 0;\n\n}\n\nul.left-bar-menu li a {\n  color: green;\n  font-size: 15px;\n  font-weight: 400;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.aboutusdv p {\n  color: #878787;\n  line-height: 28px;\n  letter-spacing: 0.05em;\n  text-align: justify;\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px !important;\n}\n\nul.righ-bar-menu li {\n  padding: 8px 10px;\n  right: 0;\n  position: relative;\n}\n\np {\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px !important;\n}\n\nselect {\n  padding: 3px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.right-inner-addon.is-active {\n  position: relative;\n  margin-bottom: 20px;\n  width: 108%;\n  right: 15px;\n  padding: 13px 13px 0;\n  margin-left: -15px;\n}\n\na.link-bottom-footer {\n  font-weight: bold !important;\n  color: #fff;\n  font-size: 15px !important;\n  font-family: \"Blogger Sans\" !important;\n\n}\n\n\ni.fa.fa-angle-down.down-arrow {\n  font-size: 20px;\n  position: relative;\n  top: 3px;\n  line-height: 0;\n  left: 3px;\n  color: green;\n}\n\nul.hdr-scl {\n  margin: 0;\n}\n\nul.hdr-scl li a i {\n  font-size: 20px;\n}\n\nspan.dropdown-toggle:hover ul.dropdown-menubar {\n  display: block;\n  margin-top: 10px;\n  margin-left: 12px;\n}\n\nspan.dropdown-toggle {\n  padding: 21px 10px;\n}\n\n.hdr-social {\n  text-align: center;\n  margin: 37px 0 20px;\n}\n\n.form-group .form-control:focus {\n  box-shadow: none;\n}\n\n.ctnform textarea {\n  width: 100%;\n  display: block;\n  border: none;\n  height: 100px;\n  padding: 15px;\n  background-color: #efefef;\n  border: none;\n  margin-bottom: 25px;\n  border-radius: 4px;\n}\n\nul.footermenu li a {\n  font-family: \"Blogger Sans\" !important;\n  font-size: 15px;\n  text-decoration: none;\n  font-weight: 300;\n}\n\nul.footermenu li {\n  display: block;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.foot-add p {\n  font-size: 15px;\n  margin-right: 30px;\n}\n\n.created-info {\n  font-family: \"Blogger Sans\" !important;\n}\n\nspan.hdr-social ul.hdr-scl li i {\n  padding: 5px;\n}\n\n.foot-add .created-info {\n  margin-top: 12px;\n  font-size: 15px;\n  margin-bottom: 9px;\n}\n\nul.nav.navbar-nav li.hover-dropdown ul.dropdown-menubar li a {\n  color: green;\n}\n\n.addressact span.shipping-action a {\n  font-size: 18px;\n  padding-right: 6px;\n}\n\nli.hover-dropdown:hover i.fa.fa-angle-down.down-arrow {\n  color: #fff;\n}\n\n.addressact {\n  width: 20%;\n}\n\n.change-password-title {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.mored-sec h4 {\n  font-size: 14px;\n}\n\n.service-heading {\n  color: #878787 !important;\n  /* text-transform: uppercase; */\n  font-size: 20px !important;\n  font-weight: bold;\n  letter-spacing: 0.05em;\n  margin-bottom: 30px;\n  margin-top: 35px;\n  font-family: \"Blogger Sans\" !important;\n  line-height: 1.3;\n}\n\n.text-muted {\n  color: #878787;\n  line-height: 28px;\n  padding: 0;\n  letter-spacing: 0.05em;\n  margin-bottom: 25px;\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px !important;\n  font-weight: 400 !important;\n}\n\nspan.number-text {\n  background: #ccc;\n  width: 25px;\n  height: 25px;\n  text-align: center;\n  border-radius: 50%;\n  padding: 4px;\n  font-size: 14px;\n  font-weight: 700;\n  display: block;\n  color: #000;\n  margin-top: 4px;\n  margin-right: 10px;\n}\n\n.box-shadow-box {\n  box-shadow: 0 0 5px 0 #ccc;\n  padding: 25px 30px;\n  margin-top: 20px;\n  border-radius: 4px;\n}\n\nimg.img-bankcard {\n  width: 230px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n}\n\nh4.title-details {\n  font-size: 22px;\n  font-weight: 600;\n  color: #000;\n  font-family: \"Blogger Sans\" !important;\n}\n\ntable.tbl-order-cart {\n  width: 100%;\n  font-family: \"Blogger Sans\" !important;\n}\n\ntable.tbl-order-cart tr {\n  background: transparent;\n}\n\ntable.tbl-order-cart th {\n  padding: 8px 15px;\n  border-bottom: 1px solid #ccc;\n}\n\ntable.tbl-order-cart td {\n  padding: 8px 15px;\n  border-bottom: 1px solid #ccc;\n}\n\n.billing-address-sec p {\n  margin-bottom: 4px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.title-pretext {\n  font-family: \"Blogger Sans\" !important;\n}\n\n.btn-previous-tabs {\n  background: green;\n  color: #fff;\n}\n\n.btn-next-tabs {\n  background: green;\n  color: #fff;\n}\n\n.button-row {\n  margin-top: 20px;\n}\n\n.btn-right {\n  float: right;\n}\n\nspan.border-saprate {\n  background: #ccc;\n  width: 58%;\n  height: 1px;\n  margin: 14px 0;\n  margin-left: 0;\n}\n\nspan.required-mark {\n  color: red;\n}\n\n.custom-table-style tr td:first-child {\n  text-align: left;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.dateicon {\n  background-size: 18px !important;\n  background-position: right 10px center !important;\n  background-repeat: no-repeat !important;\n}\n\n.timeicon {\n  background-size: 20px !important;\n  background-repeat: no-repeat !important;\n  background-position: 99% !important;\n}\n\n.order-billing-section .form-control {\n  font-family: \"Blogger Sans\" !important;\n}\n\nselect {\n  background-position-x: 99% !important;\n}\n\n.banner-section {\n  background-repeat: no-repeat;\n  background-size: 100%;\n  padding: 110px 0 255px;\n  background-position: center bottom;\n}\n\n.banner-section1 {\n  background-repeat: no-repeat;\n  background-size: 100%;\n  padding: 115px 0;\n  background-position: center center;\n}\n\n.bathing-text {\n  font-size: 30px;\n  font-weight: 600;\n  color: #fff;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.img-cleanses {\n  width: 85%;\n  height: 100%;\n}\n\n.ozone-heading {\n  color: green;\n  font-size: 48px;\n  font-weight: 700;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.atopic-dermatitis {\n  font-size: 20px;\n  font-weight: 600;\n  color: #3b3b3b;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.ozone-content {\n  margin-top: 40px;\n}\n\n.bacteria {\n  width: 70px;\n  display: flex;\n  padding: 10px;\n  align-items: center;\n  justify-content: center;\n}\n\n.allergy-icon {\n  border: 2px solid #377d22;\n  width: 75px;\n  border-radius: 50%;\n  height: 75px;\n  margin: 0 auto;\n}\n\n.bacteria-title {\n  margin-top: 15px;\n  font-size: 16px;\n}\n\n.ozone-row {\n  padding: 0 70px;\n}\n\n.bacteria-col {\n  text-align: center;\n  margin-top: 20px;\n}\n\n\n.destroy-viruses-section {\n  background: linear-gradient(green, #88ca73);\n  padding: 70px 0;\n  margin-bottom: 80px;\n}\n\n.viruses-text {\n  color: #fff;\n  text-align: center;\n  padding: 0 50px;\n}\n\n.virus {\n  font-size: 48px;\n  font-weight: 700;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.study {\n  font-size: 36px;\n}\n\n.product-features-section {\n  padding: 0 50px;\n  margin-bottom: 80px;\n}\n\n.product-title {\n  font-size: 22px;\n  text-transform: uppercase;\n  text-align: center;\n  font-weight: 500;\n  color: #3b3b3b;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.fungicidal-properties {\n  font-weight: 600;\n  padding: 30px 60px;\n  text-align: center;\n  color: #3b3b3b;\n  font-size: 36px;\n  line-height: 50px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.anti-inflammatory-properties-left {\n  margin-top: 50px;\n}\n\n.anti-inflammatory {\n  text-align: right;\n  font-size: 24px;\n  font-weight: 600;\n  margin-bottom: 50px;\n  line-height: 32px;\n  color: #3b3b3b;\n  position: relative;\n  font-family: \"Blogger Sans\" !important;\n}\n\np.anti-inflammatory:after {\n  content: \"\";\n  position: absolute;\n  background: #377d22;\n  height: 30px;\n  width: 4px;\n  right: -10px;\n  top: 0;\n}\n\n.image-inflam {\n  width: 100%;\n  border: 1px solid #dbdbdb;\n  padding: 10px;\n}\n\n.anti-inflammatory-properties-right {\n  margin-top: 50px;\n}\n\np.anti-parasitic {\n  text-align: left;\n}\n\np.anti-parasitic:after {\n  left: -10px;\n  right: unset;\n}\n\n.text-section {\n  font-size: 16px;\n  color: #3b3b3b;\n  line-height: 24px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.additives p {\n  color: green;\n  font-size: 28px;\n  line-height: 32px;\n}\n\n.product-contain {\n  padding: 0 60px;\n}\n\n.microoragnisms-section {\n  background-color: #f7f7f7;\n  margin-top: 50px;\n}\n\n.img-product-2 {\n  width: 100%;\n  height: 100%;\n}\n\n.microoragnisms-content-section {\n  margin: 50px 50px 0;\n}\n\n.microoragnisms-text h2,\nh4 {\n  font-weight: 600;\n  color: #3b3b3b;\n}\n\n.microoragnisms-text h4 {\n  margin-top: 25px;\n  line-height: 24px;\n}\n\n.aging-img .process {\n  width: 70px;\n  padding: 10px;\n}\n\n.aging-process-section {\n  display: flex;\n  margin-top: 40px;\n  width: 80%;\n}\n\n.aging-img {\n  border: 2px solid green;\n  width: 75px;\n  border-radius: 50%;\n  height: 75px;\n  margin: 0 auto;\n}\n\n.aging-text {\n  margin-left: 20px;\n  color: #3b3b3b;\n  width: 80%;\n}\n\n.aging-text h3 {\n  font-weight: 600;\n  padding-bottom: 10px;\n}\n\n.aging-text p {\n  line-height: 20px;\n}\n\nimg.img-odorless {\n  width: 91%;\n  display: block;\n  margin: 0 auto;\n}\n\n.odorless-section {\n  position: relative;\n  padding: 80px 0;\n}\n\nh2.title-odorless {\n  font-size: 36px;\n  color: #3b3b3b;\n  font-weight: 600;\n  width: 56%;\n  margin: 0 auto;\n  text-align: center;\n  line-height: 50px;\n}\n\np.title-ozone-renew {\n  width: 74%;\n  margin: 20px auto 50px;\n  text-align: center;\n  color: #3b3b3b;\n  line-height: 24px;\n  font-size: 16px;\n}\n\na.btn-buy-now {\n  position: absolute;\n  left: 34%;\n  bottom: 20px;\n  background: green;\n  color: #fff;\n  padding: 14px 40px;\n  border-radius: 4px;\n}\n\na.btn-buy-now:hover {\n  color: #fff;\n}\n\n.booking-tabs-topbar {\n  padding: 60px 0;\n}\n\n.booking-test-group {\n  display: grid;\n  grid-template-columns: 14% 14% 14% 14% 14% 12% 12% 6%;\n}\n\n.tabs-steps-group {\n  position: relative;\n}\n\n.round-steps-box {\n  width: 27px;\n  height: 27px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #878787;\n  background: #fff;\n}\n\n.round-steps-box:before {\n  content: \"\";\n  height: 2px;\n  width: 100%;\n  position: absolute;\n  background: #ccc;\n  top: 13px;\n  left: 27px;\n}\n\n.active_tabs .round-steps-box {\n  background: green;\n  border-color: green;\n}\n\n.active_tabs .round-steps-box:before {\n  background: green;\n}\n\n.booking-test-group .tabs-steps-group:last-child .round-steps-box:before {\n  content: none;\n}\n\n.tabs-steps-group h4 {\n  font-size: 16px;\n  font-weight: 400;\n  margin-top: 20px;\n  margin-bottom: 0;\n  color: #878787;\n  line-height: 1.2;\n  margin-right: 60px;\n}\n\n.active_tabs h4 {\n  color: green;\n}\n\n.thank-you-message h2,\n.thank-you-message h3 {\n  color: #6c6c6c;\n  font-size: 58px;\n}\n\n.thank-you-message {\n  text-align: center;\n  margin-bottom: 50px;\n}\n\n.thank-you-message a {\n  display: inline-block;\n  margin-top: 30px;\n  padding: 12px 20px;\n  color: #fff !important;\n}\n\n.round-steps-box i.icon-checked {\n  font-size: 14px;\n  color: #fff;\n}\n\n.steps-main-section {\n  padding-bottom: 60px;\n}\n\n.steps-main-groups {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  position: relative;\n}\n\n.company-details-section,\n.sops-details-section,\n.site-visit-details-section,\n.warehouse-details-section,\n.products-details-section {\n  padding: 50px;\n  position: relative;\n}\n\n.booking-main-section {\n  position: relative;\n}\n\n.contacts-details-section,\n.regulatory-contact-details-section,\n.agreement-details-section,\n.sops-details-section,\n.site-visit-details-section,\n.warehouse-details-section,\n.products-details-section {\n  display: none;\n  position: relative;\n}\n\n.test-tooltip-section {\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  position: absolute;\n  padding: 6px 10px 5px;\n  right: 5px;\n  top: -48px;\n  display: none;\n  transition: 0.4s;\n  background: #fff;\n}\n\n.which-type-test:hover~.test-tooltip-section {\n  display: block;\n}\n\n.test-tooltip-section:after {\n  bottom: -6px;\n  right: 15px;\n  content: \"\";\n  height: 10px;\n  width: 10px;\n  position: absolute;\n  border-top: 1px solid #ccc;\n  border-left: 1px solid #ccc;\n  transform: rotate(-135deg);\n  background: #fff;\n}\n\n.test-tooltip-section p {\n  font-size: 16px;\n  color: #5c5c5c;\n  margin: 0;\n  margin-bottom: 0;\n}\n\n.cancel-sign-btn {\n  position: absolute;\n  right: 42px;\n  bottom: 10px;\n  border: none;\n  background: green;\n  color: #fff;\n  padding: 6px 8px;\n  border-radius: 4px;\n}\n\n.signature-group canvas {\n  position: relative;\n  border-radius: 4px;\n  border: 1px solid #ccc;\n}\n\n.signature-group {\n  width: 100%;\n  position: relative;\n}\n\n.btn-save-signature {\n  background: green;\n  color: #fff;\n  border: none;\n}\n\n.steps-main-section .form-label-title {\n  line-height: 1.25;\n  color: #5c5c5c;\n  margin-bottom: 8px;\n  font-weight: 400;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.steps-main-section .form-control {\n  border: 1px solid #ccc;\n  border-radius: 4px !important;\n  font-size: 14px !important;\n  font-family: \"Blogger Sans\" !important;\n  color: #121212;\n}\n\n.steps-main-section .form-group {\n  margin-bottom: 30px;\n}\n\n.form-main-title {\n  font-size: 26px;\n  color: green;\n  font-weight: 600;\n  margin-bottom: 40px;\n}\n\n.form-footer-main {\n  text-align: right;\n  margin-top: 50px;\n}\n\n.btn-cust-next,\n.btn-cust-back {\n  border: 1px solid green;\n  background: green;\n  color: #fff;\n  font-size: 16px;\n  font-weight: 500;\n  font-family: \"Blogger Sans\" !important;\n  padding: 8px 22px;\n  line-height: 1;\n  border-radius: 4px;\n}\n\n.btn-cust-back {\n  background: #fff;\n  color: green;\n  margin-right: 16px;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.border-saprate-row {\n  display: block;\n  width: 100%;\n  border-top: 1px dashed #ccc;\n  margin-top: 10px;\n  margin-bottom: 40px;\n}\n\n.contacts-details-section,\n.regulatory-contact-details-section {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n.contacts-details-section .row,\n.contacts-details-section .form-main-title,\n.contacts-details-section .form-footer-main,\n.regulatory-contact-details-section .row,\n.regulatory-contact-details-section .form-main-title,\n.regulatory-contact-details-section .form-footer-main {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.radio-group {\n  display: inline-block;\n  position: relative;\n  margin-right: 40px;\n}\n\n.radio-group input[type=\"radio\"] {\n  display: none;\n}\n\n.radio-group label {\n  color: #5c5c5c;\n  font-weight: 400;\n  margin: 0;\n}\n\n.radio-group label:before {\n  content: \" \";\n  display: inline-block;\n  position: relative;\n  top: 5px;\n  margin-right: 10px;\n  width: 20px;\n  height: 20px;\n  border-radius: 11px;\n  border: 2px solid #878787;\n  background-color: transparent;\n}\n\n.radio-group input[type=\"radio\"]:checked+label:after {\n  border-radius: 11px;\n  width: 12px;\n  height: 12px;\n  position: absolute;\n  top: 9px;\n  left: 4px;\n  content: \" \";\n  display: block;\n  background: green;\n}\n\n.radio-group input[type=\"radio\"]:checked+label {\n  color: green;\n}\n\n.radio-group input[type=\"radio\"]:checked+label:before {\n  border: 2px solid green;\n}\n\n.sops-radio-group .radio-group label:before {\n  margin: 0;\n}\n\n.checkbox-group input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox-group label {\n  color: #5c5c5c;\n  font-weight: 400;\n  margin: 0;\n}\n\n.checkbox-group label:before {\n  content: \" \";\n  display: inline-block;\n  position: relative;\n  top: 5px;\n  width: 20px;\n  height: 20px;\n  border-radius: 4px;\n  border: 2px solid #878787;\n  background-color: transparent;\n  margin-right: 10px;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked+label:after {\n  position: absolute;\n  content: \" \";\n  display: block;\n  left: 7px;\n  top: 7px;\n  width: 7px;\n  height: 12px;\n  border: solid #fff;\n  border-width: 0 3px 3px 0;\n  transform: rotate(45deg);\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked+label {\n  color: green;\n}\n\n.checkbox-group input[type=\"checkbox\"]:checked+label:before {\n  border: 2px solid green;\n  background: green;\n}\n\n.which-type-test {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #878787;\n  border-radius: 50%;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 5px;\n  font-weight: 700;\n  margin-left: 0;\n  position: relative;\n  top: 0;\n  cursor: pointer;\n}\n\n.sops-title-group span {\n  font-size: 16px;\n  color: #5c5c5c;\n  font-weight: 500;\n  margin-right: 40px;\n  margin-bottom: 10px;\n  display: inline-block;\n}\n\n.form-body-title {\n  color: #5c5c5c;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.35;\n  margin-bottom: 15px;\n}\n\n.agreement-point-section li {\n  color: #5c5c5c;\n  font-size: 16px;\n  line-height: 1.35;\n  margin-bottom: 30px;\n}\n\n.checkbox-group {\n  width: 100%;\n  position: relative;\n}\n\n.checkbox-group label {\n  font-weight: 400;\n}\n\n.agreement-details-section {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n.agreement-details-section .agreement-point-section,\n.agreement-details-section .form-main-title,\n.agreement-details-section .row,\n.agreement-details-section .form-body-title,\n.agreement-details-section .form-footer-main {\n  padding-left: 50px;\n  padding-right: 50px;\n}\n\n.reuired-sign {\n  color: red;\n}\n\n.error_message {\n  color: red;\n  margin-top: 4px;\n  display: inline-block;\n  font-size: 14px;\n}\n\n.sops-details-section .error_message,\n.site-visit-details-section .error_message,\n.warehouse-details-section .error_message,\n.products-details-section .error_message {\n  margin-left: 5px;\n}\n\n.agreement-point-section {\n  margin-bottom: 40px;\n}\n\n.register-link-group {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  gap: 19px;\n}\n\n.register-page-link {\n  padding: 70px 0;\n}\n\n.registerbox {\n  text-align: center;\n  margin: 0;\n  position: relative;\n  width: 220px;\n  height: 218px;\n  border: 1px solid #989898;\n  transition: 0.1s;\n}\n\n.registerbox h4 {\n  margin-top: 35px;\n  font-size: 18px;\n  font-weight: 600;\n  line-height: 1.35;\n  color: #989898;\n  text-decoration: none;\n  font-family: \"Blogger Sans\";\n}\n\n.registerbox:hover h4 {\n  color: green;\n}\n\n.registerbox a {\n  color: green;\n}\n\n.register-link-group a {\n  display: inline-block;\n}\n\n.registerbox .img-centered {\n  margin-top: 40px;\n}\n\n\n\n.sops-title-group span:last-child {\n  margin-right: 0;\n}\n\n.sops-radio-group .radio-group:last-child {\n  margin-right: 0;\n}\n\n/* .registration_details {\n  padding-top: 20px;\n  padding-bottom: 40px;\n}\n\n.registration_details .details_heading_section {\n  display: flex;\n  justify-content: space-between;\n  color: green;\n  padding: 12px;\n  background-color: #f3fbf3;\n  margin-bottom: 20px;\n} */\n\n.details_heading {\n  font-size: 22px;\n  font-weight: 400;\n  line-height: 22px;\n  margin: 0;\n}\n\n.details_name_sec .details_txt {\n  font-size: 16px;\n}\n\n.details_name_sec .details_title {\n  font-size: 18px;\n}\n\n.sops_training label {\n  margin-bottom: 0;\n}\n\n.details_list_section .border-remove-table {\n  padding: 0;\n}\n\n.border-remove-table table tr:last-child td {\n  border-bottom: 0;\n}\n\n.border-remove-table table tr:first-child td {\n  border-top: 0;\n}\n\n.border-remove-table table tr:last-child td:first-child {\n  border-left: 0;\n}\n\n.border-remove-table table tr:last-child td:last-child {\n  border-right: 0;\n}\n\n.btn_section {\n  border-top: 1px solid #d9d9d9;\n}\n\n.btn_back {\n  border-radius: 4px;\n  border: 1px solid green;\n  color: green;\n  padding: 8px 19px;\n  color: green;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  margin-right: 0px;\n  background-color: #ffffff;\n}\n\n.btn_submit {\n  border-radius: 4px;\n  background: green;\n  color: #fff;\n  padding: 8px 19px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 16px;\n  border: none;\n}\n\n.btn_back_submit {\n  padding-top: 30px;\n  padding-bottom: 5px;\n  display: flex;\n  justify-content: end;\n}\n\n.btn_back_submit button {\n  font-family: \"Blogger Sans\" !important;\n}\n\n/* .registration_details_list {\n  margin-top: 40px;\n}\n\n.registration_details_list.agreement tr:last-child td {\n  background: #f3f3f3;\n} */\n\n.signature_img {\n  width: 150px;\n  height: 80px;\n  display: block;\n}\n\n.company_details td,\n.contact_details td,\n.regulatory_contact_details td {\n  border: none;\n}\n\n.company_details .details_list_section,\n.contact_details .details_list_section,\n.regulatory_contact_details .details_list_section {\n  border: 1px solid #ccc;\n}\n\n.regulatory-contact-details-section .text-techinical-agreement .text-techinical {\n  color: green;\n  font-weight: 600;\n  text-decoration: underline;\n  line-height: 1.4;\n}\n\n.regulatory-contact-details-section .text-techinical-agreement .text-techinical:hover,\n.regulatory-contact-details-section .text-techinical-agreement .text-techinical:focus {\n  color: #ea4a30;\n  font-weight: 600;\n  text-decoration: underline;\n}\n\n.rdio_main_inp {\n  display: none !important;\n}\n\ninput#wdaAttachedFile:focus {\n  outline: none;\n}\n\n.register_section .step-progress {\n  display: none;\n}\n\n.text-techinical-agreement span {\n  color: green;\n  font-weight: 600;\n}\n\n.text-techinical-agreement {\n  font-size: 13px;\n  margin-bottom: 6px;\n  display: inline-block;\n  color: green;\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n.text-techinical {\n  color: green;\n}\n\n@media screen and (min-width: 1200px) {\n  .registerbox:hover {\n    border: 4px solid #989898;\n  }\n}\n\n@media screen and (max-width: 1024px) and (min-width: 1000px) {\n  .register-link-group a:last-child {\n    margin-right: 0;\n  }\n\n  .register-link-group a:first-child {\n    margin-left: 0;\n  }\n\n  .register-link-group a {\n    margin: 0 10px;\n  }\n\n  .radio-group {\n    margin-right: 20px;\n  }\n\n  .sops-title-group span {\n    margin-right: 20px;\n  }\n}\n\n@media screen and (max-width: 1024px) {\n  .tabs-steps-group h4 {\n    margin-right: 20px;\n  }\n\n  .form-main-title {\n    margin-bottom: 20px;\n  }\n\n  .company-details-section,\n  .sops-details-section,\n  .site-visit-details-section,\n  .warehouse-details-section,\n  .products-details-section {\n    padding: 25px;\n  }\n\n  .contacts-details-section .row,\n  .contacts-details-section .form-main-title,\n  .contacts-details-section .form-footer-main,\n  .regulatory-contact-details-section .row,\n  .regulatory-contact-details-section .form-main-title,\n  .regulatory-contact-details-section .form-footer-main {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  .agreement-details-section .agreement-point-section,\n  .agreement-details-section .form-main-title,\n  .agreement-details-section .row,\n  .agreement-details-section .form-body-title,\n  .agreement-details-section .form-footer-main {\n    padding-left: 25px;\n    padding-right: 25px;\n  }\n\n  .agreement-details-section,\n  .contacts-details-section,\n  .regulatory-contact-details-section {\n    padding-top: 25px;\n    padding-bottom: 25px;\n  }\n\n  .border-saprate-row {\n    margin-top: 0;\n    margin-bottom: 20px;\n  }\n\n  .steps-main-section .form-group {\n    margin-bottom: 20px;\n  }\n\n  .form-footer-main {\n    margin-top: 30px;\n  }\n}\n\n@media screen and (max-width: 992px) {\n  .tabs-steps-group h4 {\n    display: none;\n  }\n\n  .register-link-group {\n    justify-content: center;\n  }\n\n  .register-link-group a {\n    margin-bottom: 30px;\n  }\n\n  .i-want-to-register {\n    margin-bottom: 30px;\n  }\n}\n\n@media screen and (max-width: 992px) and (min-width: 768px) {\n  .product-features-section .col-md-4 {\n    width: 33.33%;\n    float: left;\n  }\n\n  .microoragnisms-section .col-md-6 {\n    width: 50%;\n    float: left;\n  }\n\n  .odorless-section .col-md-4 {\n    width: 33.33%;\n    float: left;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  ul.righ-bar-menu {\n    float: none;\n    margin-top: 0px;\n  }\n\n  ul.righ-bar-menu li:first-child {\n    padding-left: 10px;\n  } \n    ul.righ-bar-menu {\n        float: none;\n        padding-left: 5px;\n        margin-top: 0px !important;\n    }\n  .banner-section {\n    background-size: cover;\n    padding: 60px 0 100px;\n  }\n\n  .bathing-text {\n    font-size: 20px;\n  }\n\n  .ozone-row {\n    padding: 0;\n  }\n\n  .ozone-heading {\n    font-size: 30px;\n  }\n\n  .virus {\n    font-size: 30px;\n  }\n\n  .study {\n    font-size: 22px;\n  }\n\n  .fungicidal-properties {\n    padding: 30px 0;\n    font-size: 30px;\n    line-height: 35px;\n  }\n\n  .product-contain {\n    padding: 0;\n  }\n\n  .product-features-section {\n    padding: 0;\n  }\n\n  .anti-inflammatory {\n    margin-bottom: 30px;\n    text-align: left;\n    padding-left: 10px;\n  }\n\n  .anti-inflammatory-properties-left {\n    margin-top: 0;\n  }\n\n  .anti-inflammatory-properties-right {\n    margin-top: 30px;\n  }\n\n  .img-cleanses {\n    width: 100%;\n  }\n\n  h2.title-odorless {\n    font-size: 36px;\n    color: #3b3b3b;\n    font-weight: 600;\n    width: 80%;\n    margin: 0 auto;\n    text-align: center;\n    line-height: 38px;\n  }\n\n  img.img-odorless {\n    margin-bottom: 50px;\n  }\n\n  .destroy-viruses-section {\n    margin-bottom: 50px;\n  }\n\n  .aging-process-section {\n    width: 100%;\n  }\n}\n\n\n  .registerbox {\n    width: 100%;\n  }\n\n  .register-link-group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 19px;\n  }\n\n  .register-page-link {\n    padding: 70px 0px;\n  }\n\n  .registerbox {\n    text-align: center;\n    margin: 0px;\n    position: relative;\n    width: 220px;\n    height: 218px;\n    border: 1px solid #989898;\n    transition: 0.1s;\n  }\n\n  .registerbox h4 {\n    margin-top: 35px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.35;\n  }\n\n  .registerbox:hover h4 {\n    color: #008000;\n  }\n\n  .registerbox a {\n    color: #008000;\n  }\n\n  .register-link-group a {\n    display: inline-block;\n  }\n\n  .registerbox .img-centered {\n    margin-top: 40px;\n  }\n\n  /* .i-want-to-register {\n    font-size: 17px !important;\n    font-weight: 600;\n    color: #008000;\n    text-transform: uppercase;\n    text-align: center;\n    margin-bottom: 65px;\n  } */\n\n  .company-details-section,\n  .sops-details-section,\n  .site-visit-details-section,\n  .warehouse-details-section,\n  .products-details-section {\n    padding: 15px;\n  }\n\n  .contacts-details-section .row,\n  .contacts-details-section .form-main-title,\n  .contacts-details-section .form-footer-main,\n  .regulatory-contact-details-section .row,\n  .regulatory-contact-details-section .form-main-title,\n  .regulatory-contact-details-section .form-footer-main {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .agreement-details-section .agreement-point-section,\n  .agreement-details-section .form-main-title,\n  .agreement-details-section .row,\n  .agreement-details-section .form-body-title,\n  .agreement-details-section .form-footer-main {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  ul.righ-bar-menu .contact-menu {\n    padding-left: 0;\n  }\n\n  span.dropdown-toggle {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .hdr-social {\n    text-align: center;\n    margin: 10px 16px 20px;\n  }\n\n  .viruses-text {\n    padding: 0;\n  }\n\n  .destroy-viruses-section {\n    padding: 50px 0;\n    margin-bottom: 50px;\n  }\n\n  .microoragnisms-content-section {\n    margin: 15px;\n  }\n\n  .microoragnisms-section {\n    padding-bottom: 50px;\n  }\n\n  h2.title-odorless {\n    font-size: 30px;\n    width: 100%;\n    line-height: 35px;\n  }\n\n  .odorless-section {\n    position: relative;\n    padding: 50px 0;\n  }\n\n  p.title-ozone-renew {\n    width: 100%;\n    margin: 20px auto 40px;\n  }\n\n  img.img-odorless {\n    width: 100%;\n    margin: 0 auto 20px;\n  }\n\n  p.anti-inflammatory:after {\n    right: unset;\n    left: 0;\n  }\n\n  .additives p {\n    font-size: 22px;\n    line-height: 30px;\n    font-family: \"Blogger Sans\", sans-serif !important;\n  }\n\n  .product-features-section {\n    margin-bottom: 50px;\n  }\n\n  .microoragnisms-text {\n    margin-top: 30px;\n  }\n\n  .microoragnisms-text h2,\n  h4 {\n    font-size: 22px;\n    font-family: \"Blogger Sans\", sans-serif !important;\n  }\n\n  .bacteria-title {\n    margin-top: 10px;\n  }\n\n  .bacteria-col {\n    margin-top: 30px;\n  }\n\n\n@media screen and (max-width: 320px) {\n  a.btn-buy-now {\n    bottom: 10px;\n  }\n}\n\n.widget-title {\n  margin-bottom: 20px;\n  font-weight: 500;\n  font-size: 22px;\n  color: #fff;\n}\n\n.foot-add {\n  background-color: green;\n  text-align: center;\n  height: 50px;\n  margin-top: 30px;\n}\n\n.hdr-scl a {\n  color: #fff;\n}\n\n.foot-add1 {\n  background-color: green;\n  margin-top: 30px;\n  padding-top: 50px;\n}\n\n.company_number {\n  font-weight: 700;\n}\n\n.foot-add p {\n  padding-top: 11px;\n  font-family: \"Blogger Sans\" !important;\n  line-height: 30px;\n  margin-bottom: 0;\n  color: #fff;\n}\n\n.hdr-social {\n  margin: 0 3px 14px;\n}\n\n.terms-condition-section {\n  margin-bottom: 20px;\n  margin-top: 30px;\n}\n\nspan.fb-ftr {\n  margin-right: 20px;\n  font-size: 52p;\n}\n\n.hdr-scl span {\n  display: inline-block;\n  position: relative;\n  padding: 20px 30px;\n}\n\n.hdr-scl span:before {\n  content: \"\";\n  position: absolute !important;\n  width: 500px !important;\n  border-top: 1px solid #b6c7d6 !important;\n  height: 3px !important;\n  top: 50% !important;\n  margin-top: -3px !important;\n}\n\n.hdr-scl:after {\n  content: \"\";\n  position: absolute;\n  width: 500px;\n  border-top: 1px solid #b6c7d6;\n  height: 3px;\n  bottom: 48px;\n  right: 20px;\n}\n\n.hdr-scl span:before {\n  right: 100%;\n}\n\n.hdr-scl span:after {\n  left: 100%;\n}\n\ni.fa.fa-facebook {\n  padding-right: 20px;\n  font-size: 24px;\n}\n\ni.fa.fa-linkedin {\n  font-size: 24px;\n}\n\n.foot-add {\n  background-color: green;\n  text-align: center;\n  height: 50px;\n  margin-top: 30px;\n}\n\n.foot-add p {\n  padding-top: 11px;\n  font-family: \"bloggerSans\" !important;\n  font-family: \"Blogger Sans\" !important;\n  line-height: 30px;\n  color: #fff;\n}\n\n.footermenu {\n  padding: 0;\n  list-style: none;\n  line-height: 26px;\n}\n\n.footermenu li a {\n  color: #fff;\n}\n\n.footermenu li a:hover {\n  color: #fff;\n}\n\n.footermenu li {\n  font-size: 15px !important;\n  color: #fff;\n  margin-bottom: 5px;\n}\n\na.terms {\n  color: #fff;\n  text-align: center;\n  font-family: \"Blogger Sans\" !important;\n  text-decoration: none;\n  font-style: 14px;\n}\n\n.created-info {\n  margin-top: 0;\n  margin-bottom: 7px;\n  text-align: center;\n  color: #fff;\n  margin-right: 21px;\n  font-size: 14px !important;\n}\n\n.develop {\n  margin-bottom: 50px;\n}\n\n.aboutusdv:last-child {\n  margin-bottom: 66px;\n}\n\n.service-image_new img {\n  max-width: 89%;\n  height: 143px;\n  border-radius: 100%;\n  border: 1px solid green;\n}\n\n.login-dropdown a {\n  padding: 20px 0;\n}\n\n.login-dropdown:hover .down-arrow {\n  color: green !important;\n}\n\n.open_custom_menu {\n  display: block !important;\n}\n\n.form-group label {\n  font-size: 15px !important;\n  font-weight: 400 !important;\n}\n\n.mat-label {\n  display: block;\n  font-size: 16px;\n  transform: translateY(18px);\n  color: #979797;\n  transition: all 0.2s;\n  font-family: Verdana, sans-serif !important;\n}\n\n.is-completed .mat-label {\n  font-weight: 400;\n  font-size: 11px !important;\n  transform: translateY(0);\n}\n\n.added {\n  padding: 15px;\n}\n\n.form-group .form-control-mat-input1 {\n  display: block;\n  font-size: 16px;\n  font-family: \"Blogger Sans\" !important;\n  border-radius: 4px;\n  width: 100%;\n  height: 34px;\n  padding: 6px 12px;\n  margin-top: 10px;\n  box-shadow: none;\n  outline-offset: none;\n  background: transparent !important;\n}\n\n.form-group .form-control {\n  border: none;\n  border-radius: inherit;\n  box-shadow: none;\n  outline-offset: none;\n  background: transparent !important;\n}\n\n.step-content-foot {\n  text-align: center;\n  padding: 20px 0 50px;\n}\n\n.step-content-foot button.active {\n  background-color: #008000;\n  color: #fff;\n  font-family: \"Blogger Sans\" !important;\n  /* font-size: 14px; */\n  border-radius: 22px;\n  padding: 8px 40px;\n}\n\n.owl-theme .owl-item img {\n  display: block;\n  width: 193px;\n}\n\na {\n  text-decoration: none !important;\n  cursor: pointer;\n  outline: none;\n  color: #5c5c5c;\n  font-size: 14px;\n}\n\n.select_opt {\n  margin-top: 10px;\n  width: 100% !important;\n  margin-left: 0px;\n}\n\n.formdetailstitle {\n  text-align: center;\n  font-family: \"Vardana\", sans-serif !important;\n  font-size: 24px !important;\n  color: #0f870f;\n  text-transform: capitalize;\n  width: 100%;\n  line-height: 0.1em;\n  margin: 10px 0 20px;\n}\n\n.aboutusdv h1 {\n  color: hsl(153, 100%, 20%);\n  font-size: 26px;\n  font-weight: 600;\n  line-height: 1.3em;\n  margin-bottom: 0;\n  font-family: \"Blogger Sans\" !important;\n  padding: 0 0 12px;\n}\n\n.aboutusdv p {\n  color: #878787;\n  line-height: 28px;\n  letter-spacing: 0.05em;\n  text-align: justify;\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px !important;\n\n}\n\n.aboutusdv ol li {\n  color: #878787;\n  line-height: 28px;\n  letter-spacing: 0.05em;\n  text-align: justify;\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px !important;\n}\n\nli {\n  white-space: normal;\n  display: inline-block;\n  padding: 0;\n  margin: 0;\n}\n\nh4 {\n  color: green !important;\n  text-decoration: none !important;\n  padding-bottom: 15px;\n  font-weight: 600;\n  margin-top: 28px;\n  margin-bottom: -8px;\n}\n\nb,\nstrong {\n  font-weight: 700;\n}\n\n.aboutusdv ul li {\n  color: #878787;\n  line-height: 28px;\n  letter-spacing: 0.05em;\n  text-align: justify;\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px;\n}\n\ndiv#designer-details {\n  background: green;\n}\n\n.cookie-foot-add {\n  background-color: green;\n  text-align: center;\n  height: 50px;\n  margin-top: 30px;\n}\n\n.cookie-foot-add p {\n  padding-top: 11px;\n  font-family: \"Blogger Sans\" !important;\n  line-height: 30px;\n  margin-bottom: 0;\n  color: #fff;\n}\n\n.footermenu {\n  padding: 0;\n  list-style: none;\n}\n\n.add {\n  font-size: 15px;\n  color: #7b7b7b;\n  margin-bottom: 5px;\n}\n\n.add-btn {\n  color: #7b7b7b;\n}\n\n.add-btn:hover {\n  color: green;\n}\n\n.ctnform input {\n  width: 100%;\n  display: block;\n  border: none;\n  height: 40px;\n  padding: 0 15px;\n  background-color: #efefef;\n  border: none;\n  margin-bottom: 25px;\n  border-radius: 4px;\n}\n\n.cookie-foot-add .hdr-scl {\n  list-style: none;\n}\n\n.cookie-foot-add .hdr-social {\n  float: right;\n  margin: 10px 0;\n}\n\n.cookie-foot-add .hdr-scl li {\n  display: inline-block;\n  width: 30px;\n  height: 30px;\n  line-height: 28px;\n  background-color: #999;\n  text-align: center;\n}\n\n.cookie-foot-add .hdr-scl li:hover {\n  background: green;\n}\n\n.cookie-foot-add .hdr-scl li:hover a {\n  color: #fff;\n}\n\n.cookie-foot-add .hdr-scl a {\n  color: #fff;\n}\n\n.cookie-foot-add p {\n  display: inline-block;\n}\n\n.cookie-foot-add .hdr-scl li.lk-ftr:hover {\n  background-color: #0077b5 !important;\n}\n\n.cookie-foot-add .hdr-scl li.fb-ftr:hover {\n  background-color: #3c5798 !important;\n}\n\nli.fb-ftr {\n  margin-right: 15px;\n}\n\ninput:focus {\n  color: #111 !important;\n}\n\n.cookie-foot-add .created-info {\n  margin-top: 0;\n  margin-bottom: 7px;\n  width: 91%;\n  color: #fff;\n}\n\n.cookie-foot-add .hdr-social {\n  margin-bottom: 0;\n  position: relative;\n  bottom: -15px;\n}\n\n.cookie-foot-add .hdr-scl:after {\n  display: none;\n  content: \"\";\n  position: absolute;\n  width: 500px;\n  border-top: 1px solid #b6c7d6;\n  height: 3px;\n  top: 41%;\n  margin-top: -3px;\n}\n\n\n.registerdiv,\n.logindiv {\n  margin-top: 150px;\n}\n\n.logo-margin {\n  padding: 10px 0 20px;\n}\n\n.error {\n  color: red;\n}\n\n.logotxt1 {\n  color: green;\n  font-weight: 700;\n  font-size: 26px;\n}\n\n.logotxt2 {\n  color: #878787;\n  font-weight: 700;\n  font-size: 26px;\n}\n\n.forgotlable {\n  font-size: 12px;\n  float: right;\n  margin: -10px 0 10px;\n}\n\n.btn {\n  padding: 10px !important;\n  font-size: 11px !important;\n  font-weight: 700 !important;\n  letter-spacing: 0;\n  text-transform: uppercase;\n  color: #fff !important;\n  background-color: #008000 !important;\n  border-color: #008000 !important;\n}\n\n.form-control {\n  border-radius: 0;\n  font-weight: 400;\n  padding: 5px;\n}\n\na {\n  outline: none;\n  font-family: \"Open Sans\";\n  text-decoration: none;\n}\n\na {\n  color: #337ab7;\n  text-decoration: none;\n}\n\n.panel-default>.panel-heading {\n  color: #333 !important;\n  background-color: #f5f5f5 !important;\n  font-size: 16px !important;\n  font-family: Calibari !important;\n}\n\n.panel-heading {\n  padding: 10px 15px !important;\n}\n\n.card {\n  margin-bottom: 15px;\n  padding: 18px 10px;\n  border: 0 solid #e7e7e7;\n  border-radius: 4px;\n  box-shadow: 0 5px 20px #0000000d;\n  display: inline-block;\n  width: 100%;\n}\n\n.media-left i {\n  font-size: 45px;\n  color: green;\n}\n\n.media-text-right {\n  float: right;\n  display: inline-block;\n  text-align: right;\n}\n\n.media-left {\n  display: inline-block;\n}\n\n.media-text-right h2 {\n  font-size: 24px;\n  margin-bottom: 10px;\n  font-family: Calibri;\n  font-weight: 600;\n}\n\n.media-text-right p {\n  margin: 0;\n  font-family: Calibri;\n  font-size: 18px;\n}\n\n.content-bg {\n  background: #eee;\n}\n\n.my-panel p {\n  padding: 20px 0;\n  height: 50px;\n  border: 0;\n  border-bottom: 1px solid #eee;\n  font-family: Calibri;\n  font-size: 18px;\n}\n\n.my-panel p:last-child {\n  border-bottom: none;\n}\n\n.panel-body.my-panel-body {\n  padding: 0 15px;\n}\n\n.number {\n  float: right;\n}\n\n.panel-title {\n  font-family: Calibri;\n  font-size: 18px;\n  text-transform: uppercase;\n}\n\n.order-sec {\n  margin: 50px 0;\n}\n\ng.raphael-group-153-creditgroup tspan {\n  display: none;\n}\n\n@media screen and (max-width: 767px) {\n  .card {\n    margin: 25px 0;\n  }\n  .custom-card{\n    width: 100% !important;\n  }\n  .searchproj .justify-content-end {\n    display: flex !important;\n    justify-content: flex-start !important;\n    width: 100%;\n}\ndiv#example_filter {\n  width: 100% !important;\n  display: block !important;\n}\n.list_label{\n  width: 100%;\n}\n:where(.css-dev-only-do-not-override-1c0na6j).ant-picker{\n  width: 100%;\n}\n}\n\n.heading {\n  font-size: 23px;\n  border-bottom: 1px solid #c5c5c5;\n  margin: 0 0 0px -19px;\n  padding: 18px 20px 12px 19px;\n  color: #000;\n  background: #ffff;\n  box-shadow: 0 0 5px #d0d0d0;\n  position: fixed;\n  width: calc(100% - 228px) !important;\n  top: 0;\n  text-shadow: 0 1px 0 #fff;\n  /* text-transform: uppercase; */\n  z-index: 1000;\n}\n\n@media (min-width: 992px) {\n  .col-md-6 {\n    width: 50%;\n  }\n}\n\n.logotxt-admin1 {\n  color: green;\n  font-weight: 700;\n  font-size: 29px;\n}\n\n.heading i {\n  font-size: 20px;\n  margin-right: 4px;\n}\n\n.fa {\n  display: inline-block;\n  font: normal normal normal 14px / 1 FontAwesome;\n  font-size: inherit;\n  text-rendering: auto;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.logotxt-admin2 {\n  color: #878787;\n  font-weight: 700;\n  font-size: 29px;\n}\n\n.contacts-details-section,\n.sops-details-section,\n.site-visit-details-section,\n.warehouse-details-section,\n.products-details-section {\n  padding: 0;\n}\n\n.admin .form-group .form-control {\n  border: 1px solid #ccc;\n  border-radius: 4px !important;\n  font-size: 14px !important;\n  font-family: \"Blogger Sans\" !important;\n  color: #121212;\n}\n\n.admin .form-label-title {\n  line-height: 1.25;\n  color: #5c5c5c;\n  margin-bottom: 8px;\n  font-weight: 400;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.admin {\n  border: 1px solid #ccc;\n  border-radius: 4px !important;\n  position: relative;\n  margin-bottom: 60px;\n}\n\n.form-footer-main {\n  text-align: right;\n  margin-top: 0;\n}\n\n.tabs-steps-group h4 {\n  font-size: 16px;\n  font-weight: 400;\n  margin-top: 20px;\n  margin-bottom: 0;\n  color: #878787;\n  line-height: 1.2;\n  margin-right: 60px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.regulatory-contact-details-section .tabs-edits-section .form-label-title {\n  line-height: 1.25;\n  color: #5c5c5c;\n  margin-bottom: 8px;\n  font-weight: 400;\n  font-family: BloggerSans;\n}\n\n.which-type-test {\n  display: inline-block;\n  width: 18px;\n  height: 18px;\n  border: 2px solid #878787;\n  border-radius: 50%;\n  font-size: 14px;\n  line-height: 1;\n  padding: 0 5px;\n  font-weight: 700;\n  margin-left: 0;\n  position: relative;\n  top: 0;\n  cursor: pointer;\n}\n\n@media screen and (min-width: 1024px) {\n\n  .sops-radio-group,\n  .sops-title-group {\n    position: relative;\n    top: -4px;\n    text-align: right;\n  }\n}\n\n.agreement-point-section li {\n  color: #5c5c5c;\n  font-size: 16px;\n  line-height: 1.35;\n  margin-bottom: 30px;\n  font-family: \"Blogger Sans\" !important;\n}\n\n.agreement-details-section {\n  padding: 0;\n}\n\nbutton.btn.btn-success.btn-search {\n  display: block;\n  margin-top: 5px;\n}\n\n.btn-search {\n  background-color: green;\n  border-color: green;\n  color: #fff;\n}\n\n.custom-col {\n  /* width: 50%; */\n  /* float: left; */\n  padding: 15px;\n}\n\n.custom-card {\n  width: 350px;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-radius: 4px !important;\n  padding: 30px;\n  box-shadow: 0 2px 5px #0000001a;\n}\n\n.custom-media {\n  display: flex;\n  align-items: center;\n}\n\n.custom-media-left {\n  margin-right: 20px;\n}\n\n.custom-media-middle {\n  vertical-align: middle;\n}\n\n.custom-icon {\n  font-size: 40px;\n  color: green;\n}\n\n.text-align-end {\n  text-align: right;\n}\n\n.custom-media-body h2 {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n\n.custom-media-body p {\n  margin-bottom: 0;\n}\n\n.content-bg {\n  background: #eee;\n}\n\n.order-sec {\n  display: flex;\n  flex-wrap: wrap;\n}\n.sidebar-header.border-top {\n  position: fixed;\n  bottom: 0;\n  width: 210px;\n}\n/* .order-sec>div {\n  flex-basis: 100%;\n} */\n\n/* @media (min-width: 768px) {\n  .order-sec>div {\n    flex-basis: 50%;\n  }\n}\n\n@media (min-width: 992px) {\n  .order-sec>div {\n    flex-basis: 50%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .order-sec>div {\n    flex-basis: 50%;\n  }\n}\n}  */\n\n.loaddata {\n  font-family: \"Blogger Sans\" !important;\n  font-size: 14px;\n  font-weight: 600;\n  text-align: left;\n  color: #9d4740;\n  display: block;\n}\n\n.tbl-cell {\n  height: 100vh;\n}\n\n.readmore {\n  color: #fff;\n  background: green;\n  padding: 12px 25px;\n  border-radius: 50px;\n  font-family: \"Blogger Sans\" !important;\n  font-weight: 400 !important;\n  text-decoration: none;\n  width: 109px !important;\n}\n\n.contentwrapper .titlelable {\n  color: #626262;\n  font-size: 22px;\n  margin-top: 20px;\n}\n\n.btn-xs,\n.btn-group-xs>.btn {\n  padding: 1px 5px !important;\n  font-size: 12px;\n  line-height: 1.5;\n  border-radius: 4px !important;\n}\n\n.main-title {\n  font-size: 22px !important;\n  margin-bottom: 10px !important;\n  margin-top: 30px !important;\n  font-weight: 600 !important;\n  color: #5c5c5c !important;\n}\n\ntextarea,\nselect,\ninput {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-size: 14px !important;\n  color: #5c5c5c;\n  outline: none;\n  background-color: #fff;\n  border: 1px solid #cacaca;\n  padding: 5px;\n  line-height: 16px;\n}\n\nselect {\n  padding: 3px;\n  font-family: \"BloggerSans\";\n}\n\nul {\n  margin: 0;\n  padding: 0;\n  font-family: \"BloggerSans\";\n}\n\nform {\n  display: inline;\n}\n\nimg {\n  border: 0;\n  outline: none;\n}\n\na.nolink:hover {\n  cursor: default;\n  text-decoration: none;\n}\n\nspan.clear {\n  display: block;\n  clear: both;\n  width: 1px;\n  height: 0.001%;\n  font-size: 0;\n  line-height: 0;\n}\n\n.clear {\n  clear: both;\n}\n\nimg {\n  border: 0;\n}\n\n.tbl {\n  display: table;\n  width: 100%;\n}\n\n.tbl-row {\n  display: table-row;\n}\n\n.tbl-cell {\n  display: table-cell;\n  vertical-align: top;\n}\n\nh1,\nh2,\nh3 {\n  margin: 0;\n  padding: 0;\n}\n\na:focus {\n  outline: none;\n}\n\n.row .btn:focus {\n  outline: none;\n}\n\n.wrapper {\n  height: 100%;\n}\n\n.wrapper_login {\n  height: 100%;\n  display: table;\n  width: 100%;\n}\n\n.login {\n  height: 100%;\n  display: table-cell;\n  vertical-align: middle;\n  text-align: center;\n}\n\n.loginbox .logo {\n  margin: 0 0 10px;\n}\n\n.loginbox .tbl {\n  border: 1px solid #c5c5c5;\n  background: #fff;\n  width: 300px;\n  margin: 0 auto;\n  padding: 30px 20px;\n  box-shadow: 0 0 5px #d0d0d0;\n}\n\n.loginbox .tbl .tbl-cell {\n  padding: 7px;\n  vertical-align: middle;\n  text-align: left;\n}\n\n.loginbox .tbl .tbl-cell.col01 {\n  width: 70px;\n}\n\n.loginbox .tbl .tbl-cell.col02 .textbox {\n  width: 200px;\n}\n\n.submit {\n  padding: 6px 10px 7px;\n  background: #ea492f;\n  color: #fff;\n  border: 0;\n  font-weight: 700;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.submitboot {\n  padding: 0;\n  margin: 0;\n  background: none;\n  border: none;\n}\n\n.input-group-addon.red {\n  background: #ea492f;\n  color: #fff;\n  border: 1px solid #ea492f;\n}\n\n.input-group-addon.green {\n  background: #007301;\n  color: #fff;\n  border: 1px solid #007301;\n}\n\n.input-group-addon.black {\n  background: #222;\n  color: #fff;\n  border: 1px solid #222;\n  font-weight: 700;\n  border-radius: 4px !important;\n}\n\n.input-group-addon.green a {\n  color: #fff;\n}\n\n.input-group-addon.black a {\n  color: #fff;\n  font-weight: 700;\n}\n\n.msg {\n  color: #007301;\n  margin: 10px 0;\n  font-size: 18px;\n}\n\n.msg.error {\n  color: #ea492f;\n}\n\n.wrapper .tbl.homepage {\n  height: 100%;\n  display: table;\n  width: 100%;\n}\n\n.wrapper .homepage .tbl-cell.leftbar {\n  border-right: 1px solid #b7b7b7;\n  width: 210px;\n  background: #fff;\n  box-shadow: 0 0 5px #b7b7b7;\n  position: fixed;\n  height: 100%;\n  z-index: 1;\n}\n\n.leftbar .logom {\n  border-bottom: 1px solid #f3f3f3;\n  margin: 0 0 20px;\n}\n\n.leftbar .logom img {\n  max-width: 150px;\n}\n\n.menu a {\n  display: block;\n  padding: 7px 0 7px 15px;\n  font-size: 14px;\n  margin: 5px 0;\n  color: #373737;\n}\n\n.menu a.active,\n.menu a:hover {\n  color: #ea4a30;\n}\n\n.menu a.sep {\n  border-top: 1px solid #f0f0f0;\n  margin: 20px 0 0;\n}\n\n.menu a i {\n  padding: 0 5px 0 0;\n  font-size: 17px;\n}\n\n.wrapper .homepage .tbl-cell.content {\n  padding: 80px 50px 0 0;\n  text-align: left;\n}\n\n.heading i {\n  font-size: 20px;\n}\n\n.chpass {\n  border: 1px solid #c5c5c5;\n  background: #fff;\n  max-width: 600px;\n  padding: 30px 20px;\n  box-shadow: 0 0 5px #d0d0d0;\n}\n\n.chpass .tbl .tbl-cell {\n  padding: 7px;\n  vertical-align: middle;\n  text-align: left;\n}\n\n.chpass .tbl .tbl-cell.col01 {\n  width: 150px;\n}\n\n.chpass .tbl .tbl-cell.col02 .textbox {\n  width: 200px;\n}\n\n.searchproj {\n  margin: 60px 0 10px;\n}\n\n.searchproj .textbox {\n  width: 60%;\n  padding: 5px 6px 7px;\n}\n\n.pagination {\n  margin: 10px 0 50px;\n  padding: 10px;\n  text-align: center;\n}\n\n.pagination a {\n  padding: 1px 8px;\n  background: #fff;\n}\n\n.pagination a.selected {\n  background: #000;\n  color: #fff;\n}\n\n.tbl-row .tbl-cell {\n  padding: 5px 0;\n}\n\n.tbl-row .tbl-cell.col01 {\n  width: 80px;\n}\n\n.file {\n  border-top-right-radius: 5px;\n  border-bottom-right-radius: 5px;\n  width: 100%;\n}\n\n.datalist {\n  background: #fff;\n}\n\n.datalist .tbl-row.fldname {\n  background: #f2f2f2;\n  font-weight: 700;\n  font-size: 17px;\n  color: #000;\n}\n\n.datalist .tbl-row .tbl-cell {\n  padding: 10px;\n  vertical-align: middle;\n}\n\n.datalist .datalistrow .tbl-cell {\n  border-top: 1px dashed #dfdfdf;\n}\n\n.datalist .datalistrow.fst .tbl-cell {\n  border: none;\n}\n\n.datalist.banner_list .tbl-row .tbl-cell.col01 {\n  width: 70px;\n  text-align: center;\n}\n\n.datalist.banner_list .tbl-row .tbl-cell.col02 {\n  width: 170px;\n  text-align: center;\n}\n\n.datalist.banner_list .tbl-row .tbl-cell.col03 {\n  text-align: left;\n}\n\n.datalist.banner_list .tbl-row .tbl-cell.col04 {\n  width: 150px;\n  text-align: center;\n}\n\n.datalist.banner_list .tbl-row .tbl-cell.col05 {\n  width: 100px;\n  text-align: center;\n}\n\n.datalist.banner_list img {\n  width: 150px;\n  height: 75px;\n  padding: 1px;\n  border: 1px solid #c2c2c2;\n}\n\n.datalist.banner_list .datalist .tbl-cell.col03 {\n  font-size: 13px;\n}\n\n.datalist.banner_list .tbl-cell.col03 strong {\n  font-size: 20px;\n  display: block;\n}\n\n.datalist.banner_list .actn a {\n  display: block;\n  margin: 5px 0;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col01 {\n  width: 70px;\n  text-align: center;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col02 {\n  width: 100px;\n  text-align: center;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col04 {\n  width: 100px;\n  text-align: center;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col05 {\n  width: 150px;\n  text-align: center;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col06 {\n  width: 150px;\n  text-align: center;\n}\n\n.datalist.projectlist .datalist .tbl-cell.col03 {\n  font-size: 13px;\n}\n\n.datalist.projectlist .tbl-cell.col03 strong {\n  font-size: 20px;\n  display: block;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col06 .yes {\n  color: #008601;\n  font-weight: 700;\n  letter-spacing: 1px;\n  cursor: pointer;\n}\n\n.datalist.projectlist .tbl-row .tbl-cell.col06 .no {\n  color: #f11;\n  font-weight: 700;\n  letter-spacing: 1px;\n  cursor: pointer;\n}\n\na.bacllink {\n  text-transform: uppercase;\n}\n\na.bacllink i {\n  font-size: 12px;\n}\n\n.validate_error {\n  color: #d95c5c;\n  margin: 10px 0;\n  display: none;\n  font-weight: 600;\n}\n\n/* .bvalidator_invalid {\n  color: #d95c5c;\n}\n\n.bvalidator_invalid::-webkit-input-placeholder {\n  color: #d95c5c;\n  font-size: 14px;\n}\n\n.bvalidator_invalid:-moz-placeholder {\n  color: #d95c5c;\n  opacity: 1;\n  font-size: 14px;\n}\n\n.bvalidator_invalid::-moz-placeholder {\n  color: #d95c5c;\n  opacity: 1;\n  font-size: 14px;\n}\n\n.bvalidator_invalid:-ms-input-placeholder {\n  color: #d95c5c;\n  font-size: 14px;\n} */\n\ntextarea {\n  resize: none;\n}\n\n.tbl .tblcell {\n  display: table-cell;\n  vertical-align: top;\n}\n\n/* .leftpanel {\n  border: 0 solid #cfcfcf;\n  box-shadow: 0 0 0 #dedede;\n  padding: 0;\n} */\n\n.formfield .fieldlitbl {\n  margin: 20px 0 0;\n}\n\n.formfield .fieldlitbl.tbl .tblcell.col01 {\n  width: 200px;\n  font-family: Calibri;\n}\n\n.addnew .tbl .tblcell.col01 {\n  font-weight: 600;\n  vertical-align: middle;\n}\n\n.rightpanel {\n  padding: 0 0 0 70px;\n  width: 400px;\n}\n\n\n\n.form-control.mb {\n  margin: 0 0 10px;\n}\n\n\n/* .media_show {\n  border: 1px solid;\n  float: left;\n  margin: 4px 5px 50px 0;\n  max-width: 92px;\n  height: 75px;\n  width: 92px;\n}\n\n.media_show img {\n  height: 70px;\n  width: 100%;\n} */\n\n.btn_add {\n  padding-left: 40px;\n}\n\n.table_heading {\n  font-size: 16px;\n}\n\n.ui-menu-item {\n  background-color: #fff !important;\n  background-image: none !important;\n  border-radius: 4px !important;\n  color: #555 !important;\n  display: block !important;\n  font-size: 14px !important;\n  height: 34px !important;\n  line-height: 1.42857 !important;\n  padding: 6px 12px !important;\n  transition:\n    border-color 0.15s ease-in-out 0s,\n    box-shadow 0.15s ease-in-out 0s !important;\n  width: 100% !important;\n}\n\n.ui-state-hover,\n.ui-widget-content .ui-state-hover,\n.ui-widget-header .ui-state-hover,\n.ui-state-focus,\n.ui-widget-content .ui-state-focus,\n.ui-widget-header .ui-state-focus {\n  background: #ececec !important;\n  font-weight: 400 !important;\n  color: #212121 !important;\n}\n\n.media_checkbox {\n  float: left;\n  margin: 10px 0 0;\n  font-weight: 700;\n}\n\n.userdiv {\n  margin: 0 0 20px;\n}\n\n.btn:hover,\n.btn:focus,\n.btn.focus {\n  color: #fff !important;\n  text-decoration: none;\n}\n\n.btn_r:hover,\n.btn_r:focus,\n.btn_r.focus {\n  color: #000 !important;\n  text-decoration: none;\n  cursor: default;\n}\n\n.productoutofstock {\n  opacity: 0.4;\n}\n\n.errmsg {\n  color: #bd3400;\n  font-weight: 300;\n  z-index: 1;\n}\n\n.logotxt1 {\n  color: green;\n  font-weight: 700;\n  font-size: 35px;\n}\n\n.logotxt2 {\n  color: #878787;\n  font-weight: 700;\n  font-size: 35px;\n}\n\n.datatextcnt {\n  text-align: center;\n}\n\n.fa.fa-pencil,\n.fa.fa-trash-o,\n.fa.fa-envelope,\n.fa.fa-eye,\n.fa.fa-check {\n  color: #ae0000;\n}\n\n.deselect_address {\n  color: #ae0000;\n  cursor: pointer;\n  display: block;\n  font-weight: 600;\n}\n\n.ordertab {\n  padding: 0;\n}\n\n.dropdown-menu>li>a {\n  clear: both;\n  color: grey !important;\n  display: block;\n  font-size: 17px !important;\n  font-weight: 300;\n  line-height: 2 !important;\n  padding: 3px 20px;\n  white-space: nowrap;\n  font-family: \"BloggerSans\";\n}\n\n.dropdown-menu {\n  border-radius: 1px !important;\n  width: 84%;\n}\n\n.container .logotext {\n  padding: 0;\n  color: #fff;\n  font-family: \"BloggerSans\";\n  font-size: 14px;\n  width: 20%;\n}\n\n.serachicon {\n  display: inline-flex;\n}\n\n.main-section {\n  height: auto;\n  padding-bottom: 25px;\n}\n\n.order-productpricelist a {\n  font-size: 20px;\n  color: #fff;\n}\n\n.order-productpricelist a:hover {\n  font-size: 20px !important;\n  color: #fff;\n}\n\n.input-group-addon {\n  background-color: green !important;\n  color: #fff;\n  border: 1px solid green;\n}\n\n.dropdown ul li {\n  display: inline;\n}\n\n.fltright {\n  float: right;\n}\n\n.pharmacontaner {\n  padding: 0;\n}\n\n.shippinglable {\n  font-size: 18px;\n  font-weight: 700;\n  padding: 0 0 10px 23px;\n}\n\n/* .patientlable {\n  font-size: 20px;\n  font-weight: 700;\n  padding: 0 0 10px;\n} */\n\n.deliverybtn {\n  padding-top: 10px;\n  width: 376px;\n}\n\n.deliverybtn-orderconfirm {\n  padding-top: 10px;\n}\n\n.shippingadd {\n  padding-right: 10px;\n  padding-left: 10px;\n  padding-bottom: 60px;\n}\n\n.newshippingadd {\n  color: green;\n  cursor: pointer;\n  font-size: 15px;\n  font-weight: 700;\n  margin: 25px 0 10px 25px;\n}\n\n.paymentnone {\n  display: none;\n}\n\n.proddiv .totalpricelable {\n  padding: 10px;\n  float: right;\n}\n\n.sp-quantity {\n  width: 124px;\n  height: 42px;\n  font-family: \"ProximaNova Bold\", Helvetica, Arial;\n}\n\n.sp-minus {\n  width: 40px;\n  height: 35px;\n  border: 1px solid green;\n  float: left;\n  text-align: center;\n  color: green;\n}\n\n.sp-plus {\n  width: 40px;\n  height: 35px;\n  border: 1px solid green;\n  border-left: 0 solid #e1e1e1;\n  float: left;\n  text-align: center;\n  color: green;\n}\n\n.sp-minus a,\n.sp-plus a {\n  display: block;\n  width: 100%;\n  height: 100%;\n  padding-top: 5px;\n}\n\n.ajax-loader {\n  visibility: hidden;\n  background-color: #ffffffb3;\n  position: absolute;\n  z-index: 100 !important;\n  width: 100%;\n  height: 100%;\n}\n\n.ajax-loader img {\n  position: relative;\n  top: 50%;\n  left: 50%;\n}\n\n.ajax-loader-body {\n  visibility: hidden;\n  background-color: #ffffffb3;\n  position: absolute;\n  z-index: 100 !important;\n  width: 100%;\n  height: 100%;\n}\n\n.ajax-loader-body img {\n  position: relative;\n  top: 50%;\n  left: 50%;\n}\n\n#exTab2 {\n  padding: 80px;\n}\n\n#exTab2 h3 {\n  color: #fff;\n  background-color: #428bca;\n  padding: 5px 15px;\n}\n\n.order-list a:hover {\n  color: green;\n}\n\n.grey {\n  color: #666 !important;\n}\n\n.grey:hover {\n  color: #222 !important;\n}\n\n\n\n.all-item-info>a:hover {\n  color: #000 !important;\n}\n\n\n.pending-order-list {\n  padding-bottom: 20px;\n}\n\n.order-productpic {\n  vertical-align: top;\n}\n\n.topheader {\n  height: 36px;\n  background: #000;\n}\n\n.nopadding {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.leftpadding {\n  padding-left: 0;\n}\n\n.rightpadding {\n  padding-right: 0;\n}\n\n.searchstr {\n  padding: 25px 0 20px 25px;\n  color: #fff;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 26px;\n}\n\n.btn-searchbox {\n  background: #ecffec;\n  font-size: 20px;\n  color: #000;\n  font-family: Verdana, Segoe, sans-serif;\n  font-weight: 700;\n}\n\n\n.middlesect {\n  padding-top: 30px;\n}\n\n\n.btn-yellow {\n  background-color: #f0bf1a;\n  border-color: #7d7b7b;\n  color: #222;\n  padding: 9px;\n  font-size: 13px;\n  width: 116px;\n  font-weight: 700;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  float: right;\n  display: inline-block;\n}\n\n.btn-red {\n  background-color: #fa8072;\n  border-color: #7d7b7b;\n  color: #222;\n  padding: 9px;\n  font-size: 13px;\n  width: 116px;\n  font-weight: 700;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  float: right;\n  display: inline-block;\n}\n\n.addcartsect {\n  vertical-align: top;\n  float: right;\n  padding: 30px;\n}\n\n\ninput[type=\"number\"]::-webkit-outer-spin-button,\ninput[type=\"number\"]::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.form-control::-moz-placeholder {\n  color: #a0a0a0 !important;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n\n.paddingbottom50 {\n  padding-bottom: 50px;\n}\n\n.orderconfirmationbtn {\n  text-align: center;\n  margin: 0 auto;\n  width: 450px;\n}\n\n.pointcls {\n  cursor: pointer;\n}\n\n.btn-srch {\n  background-color: #007500;\n  border-color: #007500;\n  color: #fff;\n  height: 45px;\n}\n\n.searchbrd {\n  border-color: #007500;\n  height: 45px;\n}\n\n.form-control-calender {\n  display: block;\n  height: 34px;\n  line-height: 34px;\n  pointer-events: none;\n  position: absolute;\n  right: 15px;\n  text-align: center;\n  top: 0;\n  width: 34px;\n  z-index: 2;\n}\n\n.patient-name-lable {\n  color: green;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 22px;\n  padding-left: 10px;\n}\n\n.patient-add-lable {\n  color: #777;\n  font-family: Arial, Helvetica, sans-serif;\n  font-size: 14px;\n  padding: 5px 0 0 10px;\n  display: block;\n}\n\n.patientchkdiv {\n  vertical-align: top;\n  float: left;\n  margin-top: -10px;\n}\n\n.patientactionbdiv {\n  vertical-align: top;\n  float: right;\n}\n\n.patientactionbdiv .fa.fa-pencil {\n  color: grey;\n}\n\n.patientactionbdiv .fa.fa-pencil:hover {\n  color: #000;\n}\n\n\n.checkbox input[type=\"checkbox\"] {\n  display: none;\n}\n\n.checkbox label input[type=\"checkbox\"]+.cr>.cr-icon {\n  opacity: 0;\n  transform: scale(3) rotateZ(-20deg);\n  transition: all 0.3s ease-in 0s;\n}\n\n\n.checkbox label input[type=\"checkbox\"]:checked+.cr>.cr-icon {\n  opacity: 1;\n  transform: scale(1) rotateZ(0deg);\n}\n\n.checkbox label {\n  cursor: pointer;\n  font-weight: 400;\n  padding-left: 12px;\n}\n\n.backbtn {\n  color: grey;\n  font-size: 26px;\n  float: left;\n}\n\n.backbtn:hover {\n  color: #222;\n  font-size: 26px !important;\n  float: left;\n}\n\n.nextbtn {\n  color: grey;\n  font-size: 26px;\n  float: right;\n}\n\n.nextbtn:hover {\n  color: #222;\n  font-size: 26px !important;\n  float: right;\n}\n\n.no-visibility {\n  visibility: hidden;\n}\n\n.ui-dialog .ui-dialog-titlebar-close {\n  display: none !important;\n}\n\n.ui-widget.ui-widget-content {\n  border: 1px solid green !important;\n}\n\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.order-checkout:active,\n.order-checkout.ui-state-active:hover {\n  background: green !important;\n  border: 1px solid green;\n}\n\n.ui-dialog .ui-dialog-buttonpane {\n  border: 0 !important;\n  margin-top: -10px !important;\n}\n\n.ui-widget-content .ui-state-active,\n.ui-widget-header .ui-state-active,\na.ui-button:active,\n.grey:active,\n.grey.ui-state-active:hover {\n  background: #e9e9e9 !important;\n  border: 1px solid #e9e9e9;\n  color: #222 !important;\n}\n\n.order-success-msg {\n  font-size: 22px;\n  color: green;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.gopage {\n  font-size: 22px;\n  color: gray;\n  font-family: Arial, Helvetica, sans-serif;\n  margin-top: 35px;\n  float: left;\n}\n\n.gopage:hover {\n  font-size: 22px !important;\n  color: #00f;\n  font-family: Arial, Helvetica, sans-serif;\n  margin-top: 35px;\n  float: left;\n}\n\n.btn-grey {\n  background-color: #eceef0;\n  border: 1px solid #adb1b8;\n  color: #222;\n}\n\n.btn-next {\n  background-color: green;\n  color: #fff;\n  width: 30%;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.btn-next:hover,\n.btn-next:focus {\n  background-color: green;\n  color: #fff !important;\n  width: 30%;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\n.submit-btn {\n  display: inline;\n  position: relative;\n  left: 30%;\n  top: 25px;\n}\n\n\n\n.contentwrapper .titlelable {\n  color: #626262;\n  font-size: 22px;\n  margin-top: 40px;\n}\n\n.table-responsive {\n  overflow-x: inherit;\n}\n\n.patient-dl {\n  padding-left: 65px;\n  padding-top: 25px;\n}\n\n.order-pricesect {\n  vertical-align: top !important;\n  float: right;\n}\n\n.order-vatpercentage {\n  color: grey;\n  float: left;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  margin: 20px 0 0 10px;\n}\n\n.row.order-totalprice {\n  padding-bottom: 20px;\n}\n\n.order-lablevalue {\n  color: grey;\n  float: right;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 22px;\n  font-weight: 400;\n  margin: 20px 35px 0 0;\n}\n\n.order-totaldue {\n  color: #007f00;\n  float: left;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 17px;\n  font-weight: 700;\n  margin: 20px 0 0 10px;\n}\n\n/* .order-totalvalue {\n  color: #007f00;\n  float: right;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 22px;\n  font-weight: 400;\n  margin: 20px 35px 0 0;\n} */\n\n/* .order-patientlable {\n  color: #000;\n  font-family: Tahoma, Verdana, Segoe, sans-serif;\n  font-size: 23px;\n  padding-bottom: 20px;\n  padding-top: 40px;\n} */\n\n.patient-dl li {\n  width: 100%;\n}\n\n.print_pdf {\n  font-weight: 700;\n  padding: 5px;\n  border: 1px solid;\n  float: right;\n}\n\n.producttable {\n  position: relative;\n}\n\n@media screen and (min-width: 769px) {\n  .brandsection {\n    position: absolute;\n    right: 0;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .brandrow {\n    display: flex;\n    margin-bottom: 14px;\n    width: 100%;\n  }\n\n  .brandbox {\n    width: 50%;\n  }\n\n  .searchbox {\n    width: 50%;\n  }\n}\n\n.leftbar {\n  width: 220px !important;\n  background-color: #f8f9fa;\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1000;\n}\n\n.logom {\n  padding: 20px;\n  text-align: center;\n}\n\n.menu {\n  padding: 10px;\n  font-size: 16px;\n}\n\n.menu-item {\n  margin-bottom: 10px;\n}\n\n.submenu {\n  margin-left: 20px;\n}\n\n.menu a {\n  display: block;\n  padding: 10px;\n  color: #333;\n  text-decoration: none;\n  font-size: 16px !important;\n}\n\n.menu a:hover {\n  background-color: #e9ecef;\n  font-size: 16px;\n}\n\n.sep {\n  cursor: pointer;\n}\n\n.leftbar a {\n  text-decoration: none;\n  cursor: pointer;\n  outline: none;\n  color: #5c5c5c;\n  font-size: 15px;\n  margin-bottom: 6px;\n}\n\n.active {\n  border: none;\n}\n\n.dashboard-wrapper {\n  display: flex;\n}\n\n.content-wrapper {\n  padding: 20px;\n  width: calc(100% - 220px);\n}\n\n.custom-col {\n  /* flex: 1; */\n  margin-bottom: 20px;\n}\n\n.custom-media {\n  display: flex;\n  align-items: center;\n}\n\n.custom-media-left {\n  margin-right: 25px;\n}\n\n.custom-icon {\n  font-size: 24px;\n}\n\n.custom-media-body {\n  flex: 1;\n}\n\n.m-b-0 {\n  margin-bottom: 0;\n}\n\n.details-card {\n  margin-top: 100px;\n}\n\n.details-table {\n  font-size: 15px;\n  font-weight: 500;\n}\n\n.table th {\n  border: none !important;\n}\n\n\n.navbar .nav li a {\n  font-family: \"Blogger Sans\"!important;\n  font-size: 15px !important;\n  color: #008000 !important;\n  font-weight: 300;\n}\n\n.news-second-row {\n  margin-top: 50px !important;\n}\n\n\n.list_label {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.owl-theme .owl-nav [class*=owl-] {\n  color: #FFF;\n  font-size: 14px;\n  margin: 5px;\n  padding: 4px 7px;\n  display: inline-block;\n  cursor: pointer;\n  border: none;\n  background-color: #FFF;\n}\n\n\n\n.background-container {\n  width: 100%;\n  background: url('./components/config/assets/registration_page_bg.jpg') no-repeat center center;\n  background-size: cover;\n}\n\n.form-container {\n  position: relative;\n  z-index: 1;\n  padding: 20px;\n  border-radius: 8px;\n}\n\n\n.sidebar-nav .nav-link.active {\n  color: #fff !important;\n  width: 197px !important;\n  background: #008000 !important;\n}\n\n.sidebar-nav .nav-link:hover {\n  color: #fff;\n  width: 197px !important;\n  background: #008000;\n}\n\n.terms_condination_model {\n  height: 490px !important;\n}\n\n\n\n\n\n.details-table {\n  table-layout: fixed;\n  /* Ensures columns are of consistent width */\n  width: 100%;\n  /* Makes the table use the full width of its container */\n}\n\n.details-table th,\n.details-table td {\n  max-width: 200px;\n  /* Adjust as needed for your design */\n  overflow: hidden;\n  /* Hides overflowing content */\n  text-overflow: ellipsis;\n  /* Adds ellipsis if text overflows */\n  padding: 8px;\n  /* Adds padding to cells */\n  vertical-align: middle;\n  /* Vertically aligns text */\n}\n\n.details-table th {\n  background-color: #f8f9fa;\n  /* Light grey background for headers */\n  text-align: left;\n  /* Aligns header text to the left */\n}\n\n\n.ant-spin-dot-holder {\n  color: #008000 !important;\n}\n@media screen and (max-width: 767px) {\n  a#system_mobile_menu_toggler i {\n    color: #fff;\n}\n  div#example_filter .list_label input {\n    width: 100% !important;\n    display: block;\n}\n  .order-sec{\n    margin: 0;\n  }\n  .custom-col{\n    padding: 15px 0;\n    margin-bottom: 0;\n    width: 100% !important;\n  }\n  .searchproj{\n    margin-top: 30px;\n  }\n  .custom-media-left {\n    margin-right: 35px;\n  }\n  .heading{\n    position: relative !important;\n    top: unset !important;\n    margin: 0 !important;\n    padding: 10px 15px !important;\n    font-size: 20px !important;\n    width: 100%!important;\n  }\n  .sidebar-nav .nav-link:hover{\n    width: 100% !important;\n  }\n  .sidebar-header.border-top {\n    display: none;\n}\n  .nav-group-items{\n    display: flex !important;\n    flex-direction: column;\n  }\n  .btn_back{\n    margin-right: 0px !important;\n  }\n  .hdr_sec{\n    width: 100%!important;\n    margin-top: 60px !important;\n  }\n  #system_sidebar_id{\n    display: none;\n  }\n  .system_sidebar_active {\n    display: block !important;\n    width: 100%;\n    position: absolute;\n    top: 60px;\n    left: 0;\n    z-index: 999;\n    background: #333333 !important;\n}\n.mobile-menu-bar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n  padding: 10px 20px;\n  height: 100%;\n  background: #333333 !important;\n}\n  .mobile-menu.md\\:hidden {\n    display: flex !important;\n}\n.sidebar.sidebar-dark.leftbar {\n  width: 100% !important;\n  margin-left: 0px !important;\n  height: max-content !important;\n}\n.sidebar-header.border-bottom {\n  display: none;\n}\n  .sidebar:not(.sidebar-end):not(.show){\n    margin-left: 0;\n  }\n  .col-md-3.service4 {\n    margin-top: 40px;\n  }\n  .service-image_new img {\n    max-width: 100%;\n    height: 152px;\n    border-radius: 100%;\n    border: 1px solid green;\n    width: 152px;\n  }\n  .collapse.navbar-collapse.open-menu {\n    display: block !important;\n    position: absolute;\n    background: #fff;\n    width: 100%;\n    z-index: 111;\n    padding: 0;\n    visibility: visible;\n}\ndiv#menubar .navbar-left li:hover {\n  background: #008210;\n}\n  .collapse.navbar-collapse.open-menu ul{\n    display: block !important;\n  }\n  ul.dropdown-menubar {\n    left: 0;\n  }\n  .register-link-group a {\n    margin: 0;\n    width: 100%;\n    margin-bottom: 30px;\n  }\n\n  .registerbox {\n    width: 100%;\n  }\n\n  .register-link-group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 19px;\n  }\n\n  .register-page-link {\n    padding: 50px 0px;\n  }\n\n  .registerbox {\n    text-align: center;\n    margin: 0px;\n    position: relative;\n    width: 100%;\n    height: 218px;\n    border: 1px solid #989898;\n    transition: 0.1s;\n  }\n\n  .registerbox h4 {\n    margin-top: 35px;\n    font-size: 18px;\n    font-weight: 600;\n    line-height: 1.35;\n  }\n\n  .registerbox:hover h4 {\n    color: #008000;\n  }\n\n  .registerbox a {\n    color: #008000;\n  }\n\n  .register-link-group a {\n    display: inline-block;\n  }\n\n  .registerbox .img-centered {\n    margin-top: 40px;\n  }\n\n  .i-want-to-register {\n    font-size: 17px !important;\n    font-weight: 600;\n    color: #008000;\n    text-transform: uppercase;\n    text-align: center;\n    margin-bottom: 40px;\n  }\n\n  .company-details-section,\n  .sops-details-section,\n  .site-visit-details-section,\n  .warehouse-details-section,\n  .products-details-section {\n    padding: 15px;\n  }\n\n  .contacts-details-section .row,\n  .contacts-details-section .form-main-title,\n  .contacts-details-section .form-footer-main,\n  .regulatory-contact-details-section .row,\n  .regulatory-contact-details-section .form-main-title,\n  .regulatory-contact-details-section .form-footer-main {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  .agreement-details-section .agreement-point-section,\n  .agreement-details-section .form-main-title,\n  .agreement-details-section .row,\n  .agreement-details-section .form-body-title,\n  .agreement-details-section .form-footer-main {\n    padding-left: 15px;\n    padding-right: 15px;\n  }\n\n  ul.righ-bar-menu .contact-menu {\n    padding-left: 0;\n  }\n\n  span.dropdown-toggle {\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .hdr-social {\n    text-align: center;\n    margin: 10px 16px 20px;\n  }\n\n  .viruses-text {\n    padding: 0;\n  }\n\n  .destroy-viruses-section {\n    padding: 50px 0;\n    margin-bottom: 50px;\n  }\n\n  .microoragnisms-content-section {\n    margin: 15px;\n  }\n\n  .microoragnisms-section {\n    padding-bottom: 50px;\n  }\n\n  h2.title-odorless {\n    font-size: 30px;\n    width: 100%;\n    line-height: 35px;\n  }\n\n  .odorless-section {\n    position: relative;\n    padding: 50px 0;\n  }\n\n  p.title-ozone-renew {\n    width: 100%;\n    margin: 20px auto 40px;\n  }\n\n  img.img-odorless {\n    width: 100%;\n    margin: 0 auto 20px;\n  }\n  p.anti-inflammatory:after {\n    right: unset;\n    left: 0;\n  }\n\n  .additives p {\n    font-size: 22px;\n    line-height: 30px;\n    font-family: \"Blogger Sans\" !important;\n  }\n\n  .product-features-section {\n    margin-bottom: 50px;\n  }\n\n  .microoragnisms-text {\n    margin-top: 30px;\n  }\n\n  .microoragnisms-text h2,\n  h4 {\n    font-size: 22px;\n    font-family: \"Blogger Sans\" !important;\n  }\n\n  .bacteria-title {\n    margin-top: 10px;\n  }\n\n  .bacteria-col {\n    margin-top: 30px;\n  }\n  #servicetxt h4{\n    text-align: center;\n    margin-top: 20px;\n  }\n  .servicedv h1{\n    font-size: 30px;\n  }\n}\n/* Hetal Css Start */\n.overflow-x-h {\n  overflow-x: hidden;\n}\n.servicedv h1{\n  font-family: \"Blogger Sans\";\n  margin-bottom: 15px;\n}\nul.nav.navbar-nav.navbar-left.menu_margin{\n  margin-bottom: 8px;\n}\nnav.navbar li.hover-dropdown ul.dropdown-menubar li:hover a{\n  color: #fff;\n  padding: 0;\n}\nnav.navbar li.hover-dropdown ul.dropdown-menubar li:hover{\n  background: #008000;\n}\nul.dropdown-menubar{\n  right: 0;\n}\n.service-hr {\n  color: #ccc;\n  margin-bottom: 15px;\n  margin-top: 15px;\n}\n.mobile-menu.md\\:hidden {\n  display: none;\n}\n.servicesrow .text-muted {\n  min-height: 140px;\n  font-size: 14px !important;\n  font-family: \"Blogger Sans\" !important;\n  font-weight: 300 !important;\n}\nstrong{\n  font-weight: 500 !important;\n}\n.news-title{\n  font-family: \"Blogger Sans\";\n}\n.btn-continue-reading{\n  font-weight: 500;\n  font-family: \"Blogger Sans\";\n}\nli.hover-dropdown.login-dropdown a {\n  font-family: \"Blogger Sans\";\n  font-weight: 300;\n}\n.hdr_sec{\n  width: calc(100% - 213px);\n  display: block;\n}\n.sidebar-nav .nav-link{\n  font-family: \"Blogger Sans\";\n  font-size: 14px;\n  font-weight: 300;\n}\n.left_col{\n  min-height: 65px;\n}\n.sidebar-nav .nav-link:hover{\n  background: #008000 !important;\n}\na.sidebar-brand {\n  margin-bottom: 0;\n}\n.checkbox .cr .cr-icon {\n  color: #008000;\n  font-size: 22px;\n  left: -10%;\n  line-height: 0;\n  position: absolute;\n  top: 49%;\n}\n.btn_back{\n  margin-right: 0px !important;\n}\n/* .step-content-body input::-webkit-datetime-edit-day-field,.step-content-body input::-webkit-datetime-edit-month-field,.step-content-body input::-webkit-datetime-edit-year-field,.step-content-body input::-webkit-datetime-edit-text {\n  display: none;\n} */\n input[type=\"date\"]:focus + label,\n input[type=\"date\"]:not(:placeholder-shown) + label {\n    top: -12px;\n    left: 8px;\n    font-size: 12px;\n    color: #007bff;\n}\na.nav-link i {\n  padding-right: 8px;\n}\n.btn_back_submit .btn_submit{\n  margin-left: 10px;\n}\n.ant-table-cell, .ant-table-cell a{\n  font-family: \"Blogger Sans\" !important;\n}\nspan.ant-table-column-title {\n  font-weight: 500;\n}\n/* Heather Css End */\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
